export default {
  bank_product: {
    complete_msg:
      'Nous vous remercions sincèrement de <span>vous être abonné au produit</span>, et nous vous récompenserons avec un meilleur produit. ',
  },
  enter_amount: 'Veuillez saisir le montant.',
  reg_complete: 'Inscription terminée',
  subscription_details: "Détails de l'abonnement",
  select_withdrawal_account: 'Sélectionnez un compte de retrait',
  email_address: 'Adresse e-mail',
  product_info: 'Information produit',
  new_amount: 'Nouveau montant',
  min_running_amount: "Montant minimum d'exécution",
  max_running_amount: "Montant maximum d'exécution ",
  product_type: 'Type de produit',
  bank_product_name: 'nom du produit',
  reg_start_date: "Date de début d'inscription",
  reg_end_date: "Date de fin d'abonnement",
  exec_start_date: "Date de début d'exécution ",
  exec_end_date: "Date de fin d'exécution ",
  basic_info: 'Informations de base',
  not_applicable: "N'est pas applicable",
  subscription: 'Abonnement',
  agreed: 'Convenu',
  service_prepare: 'Le service est en cours de préparation.',
  no_buy_list: "Il n'y a pas d'historique d'achat.",
  no_sell_list: "Il n'y a pas d'historique de ventes.",
  no_list: "Il n'y a pas de liste.",
  locale_name: 'Français',
  Sale_registration: 'Inscription vente',
  apply: 'appliquer',
  status: 'status',
  wallet: 'portefeuille',
  wallet_address: 'Adresse du portefeuille',
  wallet_transfer: 'Transfert de portefeuille',
  buy: 'acheter',
  sell: 'vendre',
  all: 'tout',
  breakdown: 'Ventilation',
  act_buy: 'acheter',
  act_sell: 'vendre',
  asset: 'actif',
  select: 'sélectionner',
  no_select: 'pas de sélection',
  account: 'compte',
  balance: 'équilibre',
  login: 'Connexion',
  logout: 'déconnexion',
  register: 'Joindre en tant que membre',
  select_cancel: 'décocher',
  cancel: 'annuler',
  modify: 'éditer',
  auto_input: '(saisie automatique)',
  confirm: 'confirmer',
  look_up: 'lookup',
  password: 'mot de passe',
  account_delete: 'se désinscrire',
  detail: 'détail',
  list_detail: 'Détails détaillés',
  birth: 'anniversaire',
  welcome: 'Bienvenue',
  please_login: 'Veuillez vous connecter',
  confirmation_login: 'Vous pouvez le vérifier lors de la connexion.',
  id: 'ID',
  find_id: 'find ID',
  find_password: 'trouver le mot de passe',
  back: 'retour',
  agreement: 'accord',
  info_input: 'info d`entrée',
  success: 'complet',
  agree_msg: 'Je suis d`accord',
  all_agree: "Je suis d'accord à tous",
  agree: "Se mettre d'accord",
  confirm_password: 'Confirmez le mot de passe',
  repeat_password: 'Confirmez le mot de passe',
  next: 'Prochain',
  before: 'Retourner',
  register_success: 'Vous êtes inscrit',
  verify: 'vérifier',
  retention: 'rétention',
  allow: '(autoriser)',
  disallow: '(interdit)',
  upload_btn: 'Veuillez déposer ou cliquer ici le fichier.',
  continue_entry:
    'Veuillez saisir "[+:verification]" ci-dessous pour continuer',
  login_msg_1: 'Essayez un compte associé à des pièces sur ONEWORLDPAY !',
  login_msg_2:
    'Veuillez utiliser les transactions, les portefeuilles et les services via notre ONEWORLDPAY.',
  login_msg_3: 'ONEWORLDPAY prend en charge tous les environnements',
  cocofx_register: 'Register ONEWORLDPAY',
  register_msg_1:
    "Inscrivez-vous en tant que membre. <br /> S'il vous plaît accepter nos termes et conditions",
  register_msg_3:
    "Un compte ONEWORLDPAY donnera accès à tous les services à l'aise.",
  register_msg_all:
    "Le consentement à tous comprend le consentement aux éléments obligatoires et facultatifs, et vous pouvez sélectionner le consentement individuellement. Même si vous refusez d'accepter les options, le service est disponible.",
  register_title: "Je suis au-dessus de l'âge de 19 ans et plus.",
  register_title_2: 'Conditions ONEWORLDPAY',
  register_title_3: 'ONEWORLDPAY Conditions de services intégrés',
  register_title_4: 'levier marketing ONEWORLDPAY accord',
  register_title_5:
    "Le consentement à la collecte et l'utilisation des renseignements personnels",
  register_title_6:
    "Consentement à la collecte et l'utilisation d'informations",
  register_title_7:
    "D'accord pour recueillir des informations de profil supplémentaires",
  register_title_8: 'Entrée ONEWORLDPAY Informations sur le compte',
  register_title_9: "Informations d'entrée",
  register_msg_4:
    "Ces conditions sont applicables à tous les services fournis par la société. <br /> En acceptant ces conditions, vous pouvez utiliser ces services sans la signature d'un contrat distinct.",
  required: '[Obligatoire]',
  option: '[Sélectif]',
  otp_notice: "L'état est activé et désactivé OTP impossible.",
  required_check: "S'il vous plaît vérifier tous les champs obligatoires",
  check_input: "S'il vous plaît entrer tous les détails.",
  register_guide: 'Comment utiliser ONEWORLDPAY',
  register_step1: 'Cliquez sur le bouton ONEWORLDPAY',
  register_step2: 'Connectez-vous à ONEWORLDPAY',
  register_step3: 'Paiement / Recharge ONEWORLDPAY Connexion',
  copy: 'copier',
  no_account: "Il n'y a pas de comptes enregistrés.",
  inviter_link: 'liens de référence',
  register_used_account: 'Inscrivez-vous des comptes fréquemment utilisés',
  security_certification: 'Certification de sécurité',
  admin_security: 'Le niveau de sécurité pour {action} est {limit}.',
  company: 'entreprise',
  exact_calculation: 'réglage',
  profile: 'Informations membres',
  inquiry: 'enquête',
  announcement: 'notifications',
  information: 'informations',
  history: 'histoire',
  registration_date: "Date d'inscription",
  pay: 'Paiement',
  detail_search: 'Recherche en texte intégral',
  more_view: 'En savoir plus',
  exchange_store: 'échange',
  external_exchange_store: 'Echange externe',
  internal_exchange_store: 'Echange interne',
  external_transaction: 'Transaction externe',
  internal_transaction: 'Transaction interne',
  favorites: 'Favoris',
  no_favorite_list: "Il n'y a pas de favoris.",
  no_alias: "Pas d'alias",
  please_enter_account_name: 'Veuillez saisir le nom de votre compte.',
  variable_amount: 'Montant variable',
  changes: 'Changements',
  account_transaction_history_inquiry:
    "Demande d'historique des transactions de compte",
  exchange_application_completed: "La demande d'échange est terminée.",
  choose_how_pay_fee: 'Choisissez comment payer les frais',
  free: 'gratuit',
  closing: 'fermeture',
  relative_asset_inquiry: "Enquête sur l'actif relatif",
  please_enter_relative_account_number:
    'Veuillez saisir le numéro de compte relatif.',
  Please_enter_relative_wallet_address:
    "Veuillez saisir l'adresse relative du portefeuille.",
  memo: 'note',
  write_history_memo:
    'Il est pratique de gérer si vous écrivez un mémo historique.',
  re_enter: 'Re-entrer',
  transfer_wallet_account: "Transférer l'adresse du portefeuille",
  transfer_wallet_inquiry: 'Demande de transfert de portefeuille',
  Kiosk: 'Kiosque',
  withdrawable_amount: 'Montant retirable',
  transferred_assets: 'Transférer des actifs',
  recipient: 'Bénéficiaire',
  recipient_wallet: 'Portefeuille du destinataire',
  register_user_name_tit:
    'Nous vous recommandons de remplir le vrai nom pour la certification de sécurité.',
  register_password_tit:
    "Veuillez remplir correctement l'adresse e-mail fréquemment utilisée.",
  product_name: 'Nom du produit',
  dividend_type: 'type de dividende',
  auto: 'Automatique',
  manual: 'Manuel',
  s_usdt_protocol: 'Choisissez un protocole Tether',
  ccf: {
    what_ccf: "Qu'est-ce que le USOT?",
    key_coin:
      'La pièce clé de ONEWORLDPAY qui connecte la crypto-monnaie à la monnaie réelle',
    ccf_description:
      "C'est la pièce clé de CocoBank qui convertit diverses crypto-monnaies par échange direct et transactions C2C, et 1USOT a une valeur de 1CENT USD. USOT permet des achats et des transactions plus rapides et plus sûrs sur ONEWORLDPAY.",
    how_use_ccf: 'Comment utiliser USOT?',
    cocobank_wallet_transfer:
      'Transférez les actifs de crypto-monnaie stockés sur des échanges externes vers le portefeuille de ONEWORLDPAY.',
    ccf_conversion:
      'Convertissez la crypto-monnaie transférée vers le portefeuille en USOT via un échange de devises direct ou une transaction C2C.',
    direct_exchange_c2c_deal: 'Transaction directe de change de devises C2C',
    ccf_moved: 'Le USOT converti sera transféré sur votre compte ONEWORLDPAY.',
    how_use_account_ccf:
      'Le USOT transféré sur votre compte est utilisé comme ça!',
    freely_purchase_open_market:
      'Achetez librement des produits du marché libre avec USOT!',
    free_deposit_withdrawal:
      'Dépôt et retrait gratuits et transfert entre comptes au sein de la banque!',
    exchange_currencies_convenient:
      "L'échange entre devises devient pratique grâce au change direct de devises et aux transactions C2C!",
    offline_convenient:
      'Utilisez les services de ONEWORLDPAY plus facilement, même hors ligne!',
    how_wallets_accounts_different:
      'En quoi les portefeuilles et les comptes sont-ils différents?',
    same_means_storing_cryptocurrency:
      "Dans CocoBank, les portefeuilles et les comptes sont les mêmes moyens de stocker la crypto-monnaie, mais leur utilisation diffère en fonction du type de transaction (interne et externe) de la crypto-monnaie. En d'autres termes, le portefeuille est utilisé dans les transactions (externes) entre la bourse et ONEWORLDPAY, et le compte est utilisé dans les transactions (internes) dans ONEWORLDPAY.",
  },
  header: {
    certification_management: 'Certification / Gestion',
    c2c_enroll: 'Enregistrement achat / vente',
    wallet_list: 'Recherche de sac à main / historiques',
    wallet: 'portefeuille',
    c2c_list: 'historique des achats / ventes',
    no_c2c_sell_list: "Il n'y a pas l'historique des ventes.",
    transfer_list: 'changement de devise',
    no_transfer_list: "Il n'y a pas d'antécédents d'échange.",
    withdrawal_list: 'Dépôts / retraits',
    my_info: 'mes infos',
    home: 'principal',
    payment_history: 'Historique de facturation',
    account_transfer: 'Transfert de compte',
    transfer_history: 'Historique du transfert',
    register_used_account: 'Inscrivez-vous des comptes fréquemment utilisés',
    exchange: 'pour l échange',
    exchange_list: 'Histoire de change',
    email: 'E-mail',
    email_list: 'Histoire Email',
    otp: 'OTP',
    otp_list: 'Histoire du Bureau du Procureur',
    register_account: 'compte d enregistrement',
    calculation_account_list: 'Liste des comptes de règlement',
    security_certification: 'Certification de sécurité',
    exact_calculation: 'réglage',
    history: 'histoire',
    coco_open_market: 'COCO Open Market',
    information: 'informations',
    my_profile: 'information My',
    email_modify: 'Modifier e-mail',
    password_modify: 'Modifier votre mot de passe',
    inquiry: 'enquête',
    inquiry_history: 'Détails de contact',
    one_on_one_inquiry: '1:1 enquête',
    frequently_asked_questions: 'FAQ',
    announcement: 'notifications',
    notice: 'notifications',
    server_notice: 'Annonces de serveur',
    service_center: 'Centre de services',
    profile: 'Informations membres',
    company: 'entreprise',
    account_management: 'gestion du compte',
    do_exchange: 'pour l échange',
    transfer: 'transferts',
    look_up: 'référence',
    faq: 'FAQ',
    server: 'serveur',
    email_request: 'E-mail Contactez',
    Product_Subscription: 'Produit et abonnement',
    easy_payment: 'Paiement facile',
    easy_login: 'connexion facile',
  },
  footer: {
    footer_msg: 'Essayez un compte associé à des pièces sur ONEWORLDPAY!',
    footer_sub_msg:
      'Veuillez utiliser les transactions, les portefeuilles et les services via notre ONEWORLDPAY',
    footer_sub_msg2: 'Astuce',
    footer_sub_msg3: 'ONEWORLDPAY prend en charge tous les environnements',
    ICO: 'ICO',
    c2c: 'échange C2C',
    b2c: 'échange B2C',
    margin_exchange: 'échange de marge',
    gift_exchange: 'échange de cadeaux',
    Binary: 'options binaires',
    open_marcket: 'marché ouvert',
    game: 'jeu',
    proceed: 'transaction en cours',
    public: 'Listed',
    direct_ex: 'échange de devises direct',
    buy: 'acheter',
    sell: 'vendre',
    buy_sell: 'acheter / vendre',
    holding_coin: 'tenant une pièce',
    fee: 'informations sur la taxe',
    exchange: 'échange',
    transfer_record: 'enregistrement de transaction',
    Leverage: 'effet de levier',
    live_exchange: 'offres en direct',
    demo_exchange: 'accord de démonstration',
    contest: 'concours',
    powerball: 'powerball',
    law:
      "Juridique: numéro d'enregistrement ONEWORLDPAY.COM: 70638826927 (U 6 29 Pde Railway EastwoodNSW 2122)",
    law1:
      "Trading Point d'instruments financiers Le propriétaire de l'ensemble Ltd (Australie) est ONEWORLDPAY PTY Ltd Numéro d'enregistrement: 70638826927 marque.",
    law2:
      'Ce site Web est alimenté par ONEWORLDPAY Corp. ONEWORLDPAY Corp a approuvé le numéro 64190 - sont sous le contrôle du service des finances auxiliaire, il est enregistré dans le numéro de référence 70638826927 Australie.',
    law3:
      "ONEWORLDPAY fonctionne selon les produits financiers australiens directives d'investissement.",
    law4:
      'Réf. pas. 538324 | ABN reg. 70638826927 | BA reg. 64190. Pour vous assurer que vous êtes autorisé à utiliser les services ONEWORLDPAY dans les dispositions légales du pays de résidence est la seule responsabilité du client.',
    law5:
      "S'il vous plaît lire le COCO professionnel Divulgation des risques FX.",
    law6:
      'ONEWORLDPAY ne fournit pas de services aux États-Unis, le Belize, Maurice, Japon, Alberta, Colombie-Britannique, le Québec, la Saskatchewan Les résidents de la Saskatchewan, en Haïti, le Suriname, la Corée du Nord, Porto Rico et la zone occupée de Chypre.',
    law7:
      "S'il vous plaît se référer à la partie réglementaire de la FAQ pour plus d'informations. S'il vous plaît consulter notre information sur les risques.",
    law8:
      "zones d'accès restreint: Trading Point de Financial Instruments Ltd ne fournit pas l'investissement et les services auxiliaires aux pays du tiers monde et régions.",
    law_warn: 'Avertissement de risque:',
    law_1:
      "CFD présente un risque élevé et des produits complexes perdent rapidement leur argent en raison de l'effet de levier. 69,10% des investisseurs individuels compte, il perdra de l'argent lors de la négociation du CFD.",
    law_2:
      "Vous devez vous demander si vous pouvez accepter le fait que vous comprenez le fonctionnement CFD, plus le risque de perdre de l'argent. S'il vous plaît consulter notre information sur les risques.",
    alert_title: 'Note et Note',
    coco_market: 'COCO marché',
    ieo_market: 'IEO marché',
    news: 'Nouvelles',
    event: 'Événement',
    platform_rental_title: 'Location Platform',
    education: 'éducation',
    online_Academy: 'Académie en ligne',
    offline_Academy: 'Académie Hors ligne',
    shopping_basket: 'panier',
    best_product: 'Meilleures affaires',
    order: 'ordre',
    my_page_title: 'ma page',
    member_info_management: 'Gestion de compte',
    order_management: 'La gestion des commandes',
    my_question: 'ma question',
    one_enquiry: '01:01 Contactez',
    community: 'communauté',
    lotto: 'Powerball',
    rock_event: 'rock Event',
    quiz_game: 'Trivia Game',
    ladder_game: 'Échelle',
    tetris: 'Tetris',
    split_lotto: 'divisé Lotto',
    day_Lottery: 'loterie quotidienne',
    attendance: 'vérification de présence',
    scoop_out: 'Intégrer',
    forum: 'forum',
  },

  main_msg: {
    about_1_title: 'Le meilleur service de trading de crypto-monnaie au monde',
    about_1_msg: 'ONEWORLDPAYdirige tous les services liés aux pièces.',
    about_1_1_msg:
      'Vous pouvez acheter et vendre des pièces de crypto-monnaie au même endroit pour la première fois dans le monde.',
    about_1_2_msg:
      "En ce qui concerne l'échange direct, il est disponible à ONEWORLDPAY.",
    about_2_title: 'Système d`échange instantané',
    about_2_msg:
      'ONEWORLDPAY utilise une technologie stable de mise en parallèle multiple Technologie de conception avancée pour permettre un échange instantané J`ai un système de change de devises',
    about_3_title: 'Créer un portefeuille',
    about_3_msg:
      'ONEWORLDPAY est composé des meilleurs experts en sécurité en Corée Fournit un système WALLET avec un système de sécurité avancé.',
    about_4_title: 'Easy Trading System (C2C)',
    about_4_msg:
      ' ONEWORLDPAY construit un système de trading simple et convivial Facilitons les transactions.',
    c2c_main_msg1_1:
      "ONEWORLDPAY échangera immédiatement en utilisant la technologie d'appariement multi-parallèle fiable",
    c2c_main_msg1_2:
      "Tenir le système d'échange, en appliquant les techniques de conception avancées pour activer et",
    c2c_main_msg1_3: 'Il y a.',
    c2c_main_msg2_1:
      'Les experts en sécurité ont été ONEWORLDPAY est composé des meilleurs ingénieurs en Corée',
    c2c_main_msg2_2:
      "Equipé d'un système de sécurité l'état de l'art fournit système de portefeuille.",
    c2c_main_msg3_1:
      'ONEWORLDPAY est plus facile à construire le système commercial convivial',
    c2c_main_msg3_2: 'Il permet la négociation facile.',
  },
  toasted_msg: {
    agree_required_term: 'Veuillez accepter les termes et conditions requis',
    must_read_term:
      'Vous devez lire ou télécharger tous les termes et conditions.',
    confirm: 'confirmé',
    changed: 'changé',
    withdrawal: 'désactivé',
    register: 'enregistré',
    delete: 'Il a été supprimé.',
    title: 'Notifications',
    exchange: 'La devise directe a été traitée avec succès.',
    search: 'vu',
    deposit_request: 'Votre demande de dépôt',
    withdraw_request: 'Retrait demandé',
    create_account: 'Ouvert',
    modify: 'modifié',
    cancel: 'Annulé',
    trade_confirm: 'La transaction a été confirmée.',
    trade_reject: 'Commerce refusé.',
    copy: 'copié',
    nice_msg:
      'Si les paramètres de votre navigateur n`autorisent pas les fenêtres contextuelles, la vérification d`identité ne se déroulera pas normalement.',
    nice_title: 'guide',
    nice_success: 'Votre authentification a réussi.',
    nice_error: 'Je ne peux pas m`authentifier.',
    no_transfer: 'Pas d`échange d`informations',
    email_auth: 'L`authentification par e-mail s`est terminée avec succès',
    email_auth_send: 'Un email d`authentification a été envoyé',
    kyc_withdraw: 'La vérification du compte a réussi',
    not_allow_trade: 'Commerce inactif',
    id_find_mail_send: 'Votre e-mail a été envoyé.',
    duplicate_check: 'ID en double ou par courriel.',
    pay: 'Le paiement est terminé.',
  },
  private: {
    deal_list: 'Historique des ventes',
    app_list: 'Historique des achats',
    deal_buy_asset: 'actifs à acheter',
    buy_price: 'prix d`achat',
    confirmed_source_amount: 'Quantité de vente confirmées',
    holding_source_amount: 'Quantité de vente non engagée',
    potential_source_amount: 'quantité disponible',
    direct_market: 'échange de devises direct',
    deal_enroll: 'enregistrement des ventes',
    app_enroll: 'enregistrement d`achat',
    select_market: 'market select',
    fee_rate: 'taux de redevance',
    deal_info_input: 'saisir les informations de vente',
    deal_source_amount: 'quantité de vente',
    deal_price: 'prix de vente par pièce',
    deal_enroll_account: 'Enregistrement du compte pour la vente',
    account_select: 'sélectionner le compte',
    direct_asset_select: 'Veuillez sélectionner un actif à vendre et à acheter',
    please_select_asset: 'Veuillez sélectionner un élément.',
    basic_rate: 'prix actuel',
    direct_transfer_buy: 'à l`achat immédiatement',
    direct_transfer_sell: 'en vente immédiatement',
    direct_source_amount: 'quantité d`échange',
    direct_target_amount: 'quantité appliquée',
    direct_asset_buy: 'acheter avec {0}',
    direct_asset_sell: 'vendre comme {0}',
    selected_deal_info: 'Informations de vente sélectionnées',
    deal_source_asset_title: 'acheter un bien',
    deal_total_source_amount: 'Quantité totale des ventes',
    app_info_input: 'saisir les informations d`achat',
    app_amount: 'quantité d`achat',
    app_deal_price: 'prix unitaire',
    pay_target_amount: 'quantité à payer',
    fee: 'redevances',
    fee_calc: 'montant des frais',
    msg_fee_calc: 'Déduit de {0}',
    app_account: 'Compte pour l`enregistrement d`achat',
    app_receive_account: 'Choisissez le compte à recevoir',
    c2c_buy_select_asset: 'Veuillez sélectionner un élément à acheter',
    go_home: 'retourner au principal',
    buy_calc_spread: 'taux de change d`achat',
    sell_calc_spread: 'le taux de vente',
    cs_market_asset: 'paire d`actifs',
    cs_market_basic_rate: 'Taux de vente de base',
    transfer_type: 'type de devise',
    exchange_rate: 'taux de change appliqué',
    submit_transfer: 'échange immédiat',
    deal_source_min_amount: 'Quantité minimale d`achat',
    closed_date: 'date de fermeture',
    no_deal: 'Pas de liste de vente',
    app_price_per_quantity: 'prix par quantité',
    app_fee_amount: 'Sum total',
    select_deal_app_list: 'Achats pour certaines ventes',
    no_select_deal_app_list: 'Aucun historique d`achat pour cette vente',
    transfer_source_amount: 'quantité d`actif de référence',
    transfer_target_amount: 'quantité d`actif relative',
    transfer_basic_rate: 'Taux d`application',
    transfer_spread_rate: 'Appliquer le taux de propagation',
    transfer_exchange_rate: 'taux d`application',
    transfer_list_detail: 'Détails des détails de la demande d`échange',
    transfer_source_asset: 'actif de référence',
    transfer_target_asset: 'actif relatif',
    transfer_source_account_number: 'Numéro de compte d`actif de base',
    transfer_target_account_number: 'Numéro de compte d`actif relatif',
    transfer_detail_type: 'type de transfert',
    transfer_regdate: 'date d`application',
    transfer_asset_info: '{0} à {1} {2}',
    transfer_asset_select: 'Veuillez sélectionner un élément à remplacer.',
    msg_transfer_buy: 'acheter avec {0}',
    msg_transfer_sell: 'Vendre en tant que {0}',
    deal_fee_amount: 'frais imposés vente partie Disclosure',
  },
  wallet_page: {
    have_asset: 'détention d`actifs',
    asset_list: 'liste d`actifs',
    account_list: 'liste de comptes',
    account_create: 'créer un compte',
    deposit: 'caution',
    withdraw: 'retrait',
    deposit_list_look: 'Afficher l`historique des dépôts',
    deposit_look: 'recherche de dépôt',
    withdraw_list_look: 'recherche de l`historique des retraits',
    withdraw_look: 'recherche de retrait',
    account_modify: 'modifier le compte',
    deposit_apply: 'demander un dépôt',
    withdraw_apply: 'retrait',
    deposit_request_amount: 'le montant du dépôt',
    withdraw_request_amount: 'montant du retrait',
    withdraw_account_info: 'informations de compte de retrait',
    holder_name: 'le nom du titulaire',
    bank_name: 'bank name',
    withdraw_bank_address: 'numéro de compte',
    withdraw_address: 'adresse de l`actif',
    qr_address: 'adresse de compte',
    create_qr_address: 'Ouvrir une adresse de compte',
    account_enroll: 'Enregistrement de compte',
    account_seq: 'numéro unique de compte',
    account_title: 'nom du compte',
    regdate: 'date d`ouverture',
    before_regdate: '(avant ouverture)',
    holding_balance: 'hold amount',
    select_asset: 'sélectionner les actifs',
    create: 'ouvert',
    deposit_list: 'Historique des dépôts',
    no_deposit_list: "Il n'y a pas de détails sur la demande de dépôt.",
    deposit_apply_detail: 'Détails détaillés du dépôt',
    asset_title: 'asset name',
    request_amount: 'request amount',
    withdraw_list: 'historique des retraits',
    no_withdraw_list: "Il n'y a pas de demande de retrait.",
    withdraw_apply_detail: 'Détails détaillés de la demande',
    withdraw_fee_total_amount: 'Retrait total (y compris les frais)',
    net_amount: 'montant final',
    fee_type: 'type de taxe',
    fee_charge_type: 'Fee charge type',
    amount_of_fee: 'Amount of fee',
    create_account_address: "Compte Adresse d'ouverture",
    deposit_msg:
      "Déposer mon porte-monnaie {0} {0} de l'extérieur du porte-monnaie.",
    deposit_msg_1:
      'Une fois approuvés 350 fois (confirmation) sur la chaîne de bloc {0} transactions sont reflétées dans le portefeuille.',
    deposit_step_1: "ÉTAPE 1. Vérifiez l'ID {0} notes de service en premier.",
    deposit_step_1_1: 'Mes notes ID {0}',
    deposit_step_1_2:
      '{0} doit marquer vos propres notes ID lorsque vous déposez. {0}, sans notes de transfert ID est perdu.',
    deposit_step_1_3: 'Voir votre {0} Adresse Wallet.',
    deposit_step_1_btn: 'Remarques ID Copy',
    deposit_step_2: 'ÉTAPE 2. Vérifiez votre adresse de portefeuille.',
    deposit_step_2_1: 'QR code',
    deposit_step_2_2: 'Adresse Wallet',
    deposit_step_2_3:
      'Le montant du dépôt minimum est de <span style = "color: # 4a90e2"> {0} {1} est </ span>.',
    deposit_step_2_btn: "Porte-monnaie Copier l'adresse",
    deposit_msg_2: "S'il vous plaît vérifier",
    deposit_msg_2_1: "Cette adresse est l'adresse de dépôt seulement.",
    deposit_msg_2_2:
      'Le temps total qu\'il faut pour se conformer fin peut être affectée par la congestion du réseau de la chaîne de blocs, crypto-monnaie stars Block Chaining la congestion est <span style ="color: #4a90e2; cursor: pointer;"> ici </span> vous pouvez vérifier.',
    no_account_list: "Il n'y a pas de liste de comptes.",
    no_favorite_account_list: "Il n'y a pas de liste de comptes favoris.",
    input_account: 'Veuillez entrer votre nom de compte pour changer.',
  },
  my_page: {
    my_profile: 'information My',
    user_unique_num: "Numéro d'identification du membre",
    user_name: 'nom d`utilisateur',
    email_address: 'email',
    register_regdate: 'date d`abonnement',
    last_login: 'dernière connexion',
    auth_complete: 'authentification terminée',
    not_auth: 'Non certifié',
    expdate: 'date d`expiration',
    act_auth: 'authentifier',
    realname_auth: 'authentification de personne',
    email_auth: 'authentification e-mail',
    otp_auth: 'Authentification OTP',
    enroll: 's`inscrire',
    security: 'niveau de sécurité',
    show_security: 'Afficher le niveau de sécurité',
    auth_withdraw_address: 'authentification de l`adresse de retrait',
    apply_list: 'historique des applications',
    password_modify: 'modifier le mot de passe',
    email_modify: 'modifier l`email',
    account_block: 'Quitter le compte',
    placeholder_old_password: 'Veuillez saisir votre mot de passe existant',
    placeholder_new_password: 'Veuillez saisir un nouveau mot de passe',
    placeholder_confirm: 'Veuillez saisir une nouvelle fois',
    placeholder_password: 'Veuillez saisir votre mot de passe',
    placeholder_email: 'Veuillez saisir un nouvel e-mail',
    mail_cert_list: 'application Email Histoire',
    no_mail_list: "Pas d'historique application de messagerie.",
    nominee_detail: 'Historique des cercles phidiculaires',
  },
  kyc: {
    register_account: 'compte d enregistrement',
    kyc_enroll: 'Demander la certification KYC',
    kyc_enroll_2: 'KYC un justificatif de domicile',
    kyc_enroll_3: "KYC Raison de l'ajustement à la hausse en 4 étapes",
    auth: 'authentification',
    auth_code_send: 'envoyer le code de vérification',
    auth_code: 'code d`authentification',
    msg_auth_code:
      'Veuillez saisir votre code de vérification dans les 5 minutes',
    type_title: 'type name',
    withdraw_auth: 'authentifier l`adresse de retrait',
    withdraw_auth_tit:
      "Une procédure d'authentification de l'adresse objective pour la déduction externe. Veuillez enregistrer le compte cible et l'adresse du portefeuille à acheter.",
    select_asset: 'sélectionner les actifs',
    select_bank: 'sélectionner la banque',
    holder_name: 'le nom du titulaire',
    birth: '6 chiffres de naissance',
    address: 'adresse de l`actif',
    withdraw_list: 'demande de compte de retrait',
    bank_name: 'bank name',
    withdraw_info: 'informations sur le compte de retraits',
    withdraw_complete: 'L`actif est déjà vérifié.',
    regdate: 'date d`enregistrement',
    delete_withdraw_address: 'Adresse de débit modifié',
    delete_success_address: "L'adresse de retrait a changé.",
    kyc_cert_list: 'KYC Historique de la demande',
    no_kyc_list: "KYC est pas d'antécédents d'application.",
    no_kyc_withdraw_address_list:
      "Il n'y a pas d'antécédents d'ouverture de compte de paiement.",
    kyc_placeholder: "Entrez s'il vous plait.",
  },
  otp: {
    enter_verification_number: 'Entrez votre numéro de vérification OTP',
    otp_auth: 'Authentification OTP',
    authenticode: 'clé OTP',
    otp_deactivate: 'OTP désactiver',
    msg_authenticator_installation:
      'Veuillez installer l`application" Google Authenticator "sur votre smartphone ou votre ordinateur"',
    android: 'android ',
    or: 'ou',
    iphone_series: 'iPhone，iPad et iPod',
    windows_phone: ' Windows Phone',
    and: ', et',
    msg_microsoft_other_systems:
      'Autres systèmes, y compris le bureau Microsoft Windows',
    msg_key: 'cette clé',
    msg_use_loss_change:
      ' Écrire sur papier Utilisé lorsque vous perdez votre appareil ou devez changer votre OTP.',
    msg_brcode_touch:
      'Exécutez l`application" Google Authenticator "et appuyez sur <b> Scanner le code-barres QR </ b> en bas de l`écran.',
    msg_input_authenticode:
      'Veuillez saisir le code de vérification affiché sur l`écran du terminal dans le champ` Code d`authentification `ci-dessous.',
    otp_key: 'Clé OTP',
    otp_activate: 'OTP activate',
    otp_copy: 'Clé OTP copiée',
    otp_safe_keeping:
      'Avez-vous écrit la clé OTP sur du papier et l`avez-vous stockée en lieu sûr?',
    yes: 'oui',
    otp_register: 's`inscrire',
    otp_register_success: 'L`eregistrement OTP s`est terminé avec succès',
    otp_delete_success:
      'L`enregistrement d`effacement OTP s`est terminé avec succès.',
    msg_click_key_copy: 'Cliquez pour copier la clé',
    otp_login: 'Connexion OTP',
  },
  security: {
    show_security: 'Afficher le niveau de sécurité',
    grade: 'grade',
    condition: 'condition',
    restriction: 'restrictions',
    no_grade: 'non classé',
    no: 'aucun',
    security_title: 'Contraintes par condition de sécurité',
    banner1: 'sécurité de confiance',
    banner2:
      "Pour l'achat ou la vente par ONEWORLDPAY, ONEWORLDPAY doit assurer le chiffrement des données, la surveillance des transactions en temps réel, l'acheteur et la politique de protection du vendeur, et tous vos paiements par le biais d'un paiement sécurisé et régime de paiement ONEWORLDPAY reçu.",
    banner_invite: 'ONEWORLDPAY Ne pas avoir un compte?',
    banner_join: 'Inscription gratuite',
    banner3: 'Comment ONEWORLDPAY garde nos clients en toute sécurité',
    content1_h3: 'Acheteur de protection',
    content1_text:
      "En cas d'usure ou de dommages mibaesong de l'acheteur, ONEWORLDPAY peut compenser le montant total des paiements, y compris les frais d'expédition pour les transactions admissibles. *",
    content2_h3: 'Le vendeur',
    content2_text:
      'Si vous recevez un paiement non autorisé ou réclamations mibaesong contre le vendeur dans la vente êtes admissible, vous pouvez obtenir le montant de la protection. *',
    content3_h3: 'Le chiffrement des données',
    content3_text:
      'TLS, les connexions HTTPS pour aider à garder le paiement, la clé épinglant des applications mobiles, la conformité PCI plus sûr.',
    content3_btn: 'conformité PCI',
    content4_h3: 'prévention de la fraude',
    content4_text:
      'Toutes les transactions sont contrôlées en temps réel en analysant votre compte et de soutien pour prévenir les activités frauduleuses et la facturation.',
    sec_h2: 'vérifier Achetez',
    sec_text:
      "ONEWORLDPAY parce que la surveillance des transactions 24 heures par jour, 365 jours quand il détecte quelque chose de différent de d'habitude de contacter l'acheteur vous demande de confirmer votre connexion ou l'achat. Vérifie également ONEWORLDPAY pour tous les achats et les ventes par e-mail.",
    wran_h2: 'Si vous trouvez un des points suspects',
    warn_step1: 'Rapport.',
    warn_step1_text1:
      "Après avoir confirmé les détails n'ont pas trouvé un accord approuvé",
    warn_step1_text2: "Signaler un problème> Rapport d'activité non autorisée",
    warn_step1_text3: 'Cliquez ou contacter immédiatement ONEWORLDPAY.',
    warn_step2: "Vérifiez s'il y a d'autres problèmes.",
    warn_step2_text1:
      "Passez en revue les activités récentes de négociation et les paramètres du compte pour vous assurer que les frais supplémentaires ou des changements, s'il vous plaît signaler également ces informations.",
    warn_step3: "S'il vous plaît changer votre mot de passe.",
    warn_step3_text1:
      'Vous pouvez dans les paramètres du compte dans le menu Sécurité. Ou, si vous ne parvenez pas à vous connecter à votre compte',
    warn_step3_text2: 'Connexion> exploitation forestière Problèmes',
    warn_step3_text3: 'Cliquez ici pour obtenir réinitialisation.',
    warn_btn: 'Rapport de transactions non autorisées',
    online_h2: 'supports ONEWORLDPAY sécurisé activités en ligne.',
    online_h3: 'sécurité des comptes',
    online_text:
      'Protégez votre compte avec un mot de passe hautement sécurisé.',
    online_btn: 'En savoir plus',
    auth_incomplete: 'Certifié incomplet',
  },
  input: {
    id: "ID d'entrée",
    password:
      "un mot de passe d'entrée (8-32 chiffres comportant des caractères spéciaux)",
    repeat_password: 'Confirmez le mot de passe',
    user_name: "Nom d'utilisateur entrée",
    email_address: 'Adresse e-mail entrée',
  },
  oauth: {
    contact_msg:
      'Je veux accès aux informations suivantes dans l`application {0}.',
    agree_msg:
      '{0} Acceptez-vous que l`accès à {1} Les informations personnelles?',
    agree_info:
      'Les informations fournies seront utilisées / stockées pendant une période de service pour l`identification de l`utilisateur, les statistiques, les comptes liés CS et similaires. Informations de base et de fournir les éléments nécessaires sont les informations qui doivent être fournies à utiliser les services de ONEWORLDPAY.',
    agree_request: 'offres',
    agree_msg2:
      'Une fois accepté, les informations seront gérées conformément aux Termes et Conditions et Politique de confidentialité du service.',
    agree: 'Se mettre d`accord',
  },
  pay_head_foot: {
    account_management: 'Gestion de compte',
    settlement_account_list: 'Liste des comptes de règlement',
    account_summary_views: 'Résumé de la recherche de compte',
    fund: 'fonds',
    history: 'Historique de facturation',
    help: 'Aide',
    qa: 'Contactez-nous',
    fee: 'commission',
    secure: 'sécurité',
    go_shop: 'shopping',
    my_info: 'mon profil',
    my_page: 'Paramètres de compte',
    out: 'deconnexion',
    in: 'login',
    about: 'A PROPOS',
    blog: 'Les blogs',
    employ: "Offres d'emploi",
    site_map: 'Plan du site',
    developer: 'promoteur',
    partner: 'partenaire',
    privacy_state: 'Politique de confidentialité',
    usage: "Conditions d'utilisation",
    feed_back: "retour d'information",
    warn_to_consumer:
      "Avis aux clients: les propriétaires de moyens de paiement prépayés ONEWORLDPAY ⓒ Cocofx Pty Ltd ne nécessite pas l'approbation de l'Autorité de surveillance financière australienne. S'il vous plaît lire attentivement les termes et conditions.",
  },
  continue: 'suite',
  pay_home: {
    cocobank_title: 'ONEWORLDPAY',
    platform: 'plate-forme',
    platform_rental: 'location des plates-formes',
    cocopay_is: "ONEWORLDPAY est la croissance de l'entreprise",
    help: 'Aider.',
    home_banner_1:
      'Élargir la base de clients potentiels à travers le monde, et de faciliter la gestion des paiements,',
    home_banner_2:
      "Vendeur d'affaires Protection * et permettre de magasiner en toute sécurité avec surveillance 24/7 de la fraude.",
    home_banner_3: 'Vous pouvez réussir plus facilement.',
    home_banner_warn:
      "* Modalités et conditions applicables au vendeur de protection. S'il vous plaît se référer à votre contrat pour plus de détails sur l'admissibilité.",
    home_banner_join: 'Inscrivez-vous gratuitement.',
    home_sec1_openShop: 'Vous pouvez ouvrir un magasin à ONEWORLDPAY.',
    home_sec1_btn: 'pour faire face',
    home_sec2_h2: 'Obtenez le mode de paiement souhaité.',
    home_sec2_text1:
      'ONEWORLDPAY peut également recevoir des paiements en ligne, mobiles, et même par courriel.',
    home_sec2_text2:
      'Que ce soit le ONEWORLDPAY vendu partout qui peut aider avec le paiement plus facile et plus sûr.',
    home_sec2_online_pay: 'Paiement en ligne',
    home_sec2_online_text:
      'boutons de paiement pour jeu facile disponibles ONEWORLDPAY est très pratique lors de la réception des paiements en espèces et des paiements périodiques, dons, etc. Avec ONEWORLDPAY Checkout, les clients peuvent effectuer des paiements plus rapidement et facilement.',
    home_sec2_online_more: 'Voir plus sur le paiement en ligne',
    home_sec2_voice_invoice: 'Facture Email',
    home_sec2_voice_text:
      'Facile demande par e-mail pour le paiement à la facture libre professionnelle. Les clients étrangers ainsi que sont à la disposition des clients qui ne sont pas compte ONEWORLDPAY.',
    home_sec2_voice_more: 'Voir plus sur les factures par e-mail',
    home_sec2_exchange_pay: "Effectuer un paiement sur l'échange",
    home_sec2_exchange_text:
      "Avec le service de portefeuille intégré sur la bourse, vous pouvez recharger et acheter et vendre des pièces sur n'importe quel échange d'entreprises partenaires.",
    home_sec2_exchange_more: "En savoir plus sur la charge d'échange",
    home_sec2_mobile_pay: 'Obtenez les paiements mobiles',
    home_sec2_mobile_text:
      'Des solutions sont automatiquement optimisés pour les mobiles. Obtenez monde où encore plus facile à payer par le site mobile ou les applications Android et iOS.',
    home_sec2_mobile_more: 'Voir plus sur les paiements mobiles',
    home_sec3_h2:
      'Trouver plus de travail avec des partenaires indépendants de ONEWORLDPAY.',
    home_sec3_global:
      'ONEWORLDPAY reliera les opportunités plus globales avec les meilleurs sites indépendants du monde.',
    home_sec3_btn: 'Vérification ONEWORLDPAY freelance',
    home_sec4_h2: 'Il est facile de commencer.',
    home_sec4_banner1:
      'Apprenez tout ce que vous devez commencer par le centre des affaires de ONEWORLDPAY.',
    home_sec4_banner2:
      "Joignez-vous au compte de l'entreprise et de vérifier votre adresse e-mail",
    home_sec4_banner3: 'Certifié au compte bancaire',
    home_sec4_banner4: 'Sélectionnez une solution de paiement',
    home_sec5_h2:
      'Pourquoi le monde de nombreux opérateurs <br/>font ONEWORLDPAY de confiance.',
    home_sec5_sub_text:
      "Parce qu'il est un excellent choix. ONEWORLDPAY vous connecter au vendeur 25 appels au client au moins deux cent millions de personnes dans plus de 200 marchés dans le monde entier.",
    home_sec5_sub_text_1: "Parce qu'il est un excellent choix.",
    home_sec5_sub_text_2:
      'ONEWORLDPAY vous connecter au vendeur 25 appels au client au moins deux cent millions de personnes dans plus de 200 marchés dans le monde entier.',
    home_sec5_h3: 'Sécurité.',
    home_sec5_h3_sub1:
      "détermination automatique escroquerie, opérations de surveillance 24 heures et le vendeur et l'acheteur programme de protection pour protéger votre entreprise et vos clients.",
    home_sec5_h3_more: 'Voir plus sur le paiement en ligne',
    home_sec5_h31: 'Le monde utilise.',
    home_sec5_h31_sub1:
      "Partout dans le monde sans qu'il soit nécessaire d'entrer les informations à chaque fois que vous effectuez un paiement rapidement. Dans 203 marchés dans 26 devises, vous pouvez payer par carte de crédit, carte de débit ou ONEWORLDPAY.",
    home_sec5_h31_more: 'Voir plus sur les factures par e-mail',
    home_sec5_h32: 'Rapide.',
    home_sec5_h32_sub1:
      'Dans la plupart des cas où un paiement de client est immédiatement crédité sur votre compte ONEWORLDPAY. banque ou un paiement débitées au vendeur ou à utiliser librement dans un lieu où le paiement de ONEWORLDPAY possible.',
    home_sec5_h32_more: 'Voir plus sur la vente eBay',
    home_sec6_h2: 'structure tarifaire simple',
    home_sec6_sub:
      "ONEWORLDPAY facturera des frais que lorsque les ventes effectuées. frais ONEWORLDPAY sont fixés en fonction de l'emplacement du client et le montant des ventes.",
    home_sec6_more: 'Voir plus sur les frais',
    home_sec7_h2: 'Communauté pour la Corée du Sud vente, CBT LAB',
    home_sec7_text1:
      "Institut du commerce transfrontalier (TCC LAB) est une communauté marchande Corée ONEWORLDPAY (ONEWORLDPAY Corée) parrainé pour le commerce électronique d'outre-mer a permis.",
    home_sec7_text2:
      "CBT LAB aide l'entreprise East Coast grandir partagent l'information au niveau mondial, comme les dernières tendances, des conseils et des meilleures pratiques.",
    home_sec7_more: 'Apprenez à tirer profit de la TCC LAB',
    home_sec8_h2: 'Rencontrer les partenaires de verrouillage ONEWORLDPAY.',
    home_sec8_text1:
      "Besoin d'aide professionnelle pour votre entreprise en ligne?",
    home_sec8_text2:
      "solutions d'hébergement Web, panier, solutions de commerce électronique, telles que des œuvres d'avance ONEWORLDPAY un partenaire acheté cette aide votre entreprise.",
    home_sec8_text3:
      'Trouver un partenaire ONEWORLDPAY pour mon entreprise en ce moment.',
    home_sec8_more: 'plus de partenaires',
    home_sec9_h2: 'Devenir un vendeur global. Cela ONEWORLDPAY ensemble.',
    home_sec9_h2_1: 'Devenir un vendeur global.',
    home_sec9_h2_2: 'Cela ONEWORLDPAY ensemble.',
    home_sec9_btn: 'Créez un compte maintenant',
    home_learn_h2: 'En savoir plus',
    home_learn_li1: 'Solution de paiement Web',
    home_learn_li1_1: 'Paiements sur site marchand',
    home_learn_li1_2: 'ONEWORLDPAY Commander',
    home_learn_li1_3: 'Acheter sur eBay',
    home_learn_li1_4: 'Solutions Comparez',
    home_learn_li2: 'autres paiements',
    home_learn_li2_1: 'ONEWORLDPAY factures e-mail',
    home_learn_li2_2: 'mobile Commerce',
    home_learn_li2_3: 'Affaires pour les paiements automatiques',
    home_learn_li2_4: 'ONEWORLDPAY pour B2B',
    home_learn_li2_5: 'ONEWORLDPAY freelance',
    home_learn_li3: "l'installation et l'intégration ONEWORLDPAY",
    home_learn_li3_1: "centre d'affaires ONEWORLDPAY",
    home_learn_li3_2: 'ONEWORLDPAY Corée communauté marchande (TCC LAB)',
    home_learn_li3_3: 'Ajouter ONEWORLDPAY ONEWORLDPAY sur le site',
    home_learn_li3_4: 'Consultez le meilleur Set Guide',
    home_learn_li3_5: 'promoteur',
    home_learn_li3_6: 'partenaire',
    home_learn_li3_7: 'Comment ONEWORLDPAY',
    home_learn_li4: 'Gérer mon compte',
    home_learn_li4_1: "des applications d'affaires ONEWORLDPAY",
    home_learn_li4_2: "Paramètres de compte d'entreprise",
    home_learn_li4_3: 'Vendeur Programme de protection',
    home_learn_li4_4: 'Gérer les plaintes des clients',
    home_learn_li4_5: 'Comprendre rétrofacturation (rétrofacturation)',
    home_learn_li4_6: 'Comprendre les restrictions de compte',
    home_learn_li4_7: 'Conseils Prévention de la fraude',
    home_learn_li4_8: 'conformité PCI',
  },
  pay_nav: {
    view_your_account: 'Afficher lintégralité de votre compte',
    account_summary_views: 'Résumé de la recherche de compte',
  },
  pay_login: {
    secure_sub_title: 'Connexion et sécurité',
    secure_my_profile: 'mon profil',
    secure_update_complete:
      'Le profil environnemental et les paramètres ont été mis à jour.',
    secrue_suggest: 'Chaque fois que vous nous raconter votre expérience.',
    search: 'récupération',
    my_info: 'Informations personnelles',
    update: 'mettre à jour',
    e_mail: 'E-mail',
    default: 'informations de base',
    call: 'téléphone',
    phone: '(Mobile)',
    pay_mobile: 'Le paiement mobile',
    trading: 'Concessions mutuelles',
    password: 'mot de passe',
    change: 'changement',
    secure_qa: 'question de sécurité',
    staying: 'Rester connecté pour les achats plus rapides',
    edit: 'compilation',
    browse_manage:
      "Gérer le périphérique sélectionné et le navigateur pour maintenir l'état de connexion.",
    account_type: 'Types de compte',
    account_delete: "compte d'annulation",
    business: 'affaires',
    edit_email: "Modifier l'adresse e-mail",
    change_email: "Modifier l'adresse e-mail",
    update_email: 'Ajouter votre e-mail',
    eamil_url: 'Adresse e-mail',
    update_email_url: 'Ajoutez votre adresse e-mail',
    error_email: "Désolé. L'e-mail par défaut ne peut pas être modifié.",
    confirm_new_email: 'Vérifiez la nouvelle adresse e-mail',
    change_mail: 'Modifier e-mail',
    confirm: 'confirmation',
    changing: 'changement',
    deleting: 'effacement',
    reaming:
      "Il existe actuellement deux de l'adresse e-mail associée à votre compte. Vous pouvez ajouter plus de 5 email.",
    qa_1: 'Quel est le nom de la première école?',
    qa_2: 'Quel est le nom du premier animal de compagnie?',
    edit_phone: 'Modifier un numéro de téléphone existant',
    korea: 'République de Corée',
    explanation:
      "En ajoutant le numéro, je confirme que vous êtes d'accord pour composer automatiquement et de recevoir des appels pré-enregistrés et le texte en fonction de la raison de l'autorisation d'ajouter deux numéros sont décrits dans la Politique de confidentialité. Les taux peuvent s'appliquer.",
    edit_phone_num: 'Modifier le numéro de téléphone',
    edit_password: 'Changer mot de passe',
    confirm_password: 'Vérifiez votre mot de passe actuel',
    new_passod: 'nouveau mot de passe',
    confirm_password_new: 'Confirmer le nouveau mot de passe',
    secure_question: 'question de sécurité',
    secure_pick: 'questions à choix',
    secure_answer: 'réponse',
    edit_browse:
      'Avec ONEWORLDPAY One Touch, vous pouvez rapidement effectuer le paiement sans avoir à se connecter à chaque fois.',
    already_log: "L'utilisateur connecté sur la machine.",
    off_all: 'ONEWORLDPAY One Touch sur tous vos appareils',
    support:
      'PayPal est engagé à 100% la satisfaction des clients. Si vous avez un problème avec votre compte',
    support_center: 'Soutien à la clientèle',
    support_text1: 'Ou consultez la',
    support_text2: "S'il vous plaît se référer.",
    support_warn:
      'Si vous annulez votre compte, vous ne pouvez pas annuler vos relevés de compte seront également disparaître et des niveaux de fiabilité.',
  },
  help: {
    support_center: 'soutien',
    resolution_center: 'Résolution des différends Centre',
    qa_search: 'Rechercher Foire aux questions',
    common_qa: 'Questions générales',
    common_qa_1:
      "Qu'est-ce `Pourquoi un message d'erreur est affiché après la mise à jour de l'état de votre commande via les « obtenir des fonds Liens?",
    common_qa_2:
      'Comment puis-je retirer des fonds du compte Corée du ONEWORLDPAY?',
    common_qa_3:
      'Comment puis-je ajouter une carte de débit ou de crédit à mon compte ONEWORLDPAY?',
    common_qa_4:
      "ONEWORLDPAY J'ai oublié mon mot de passe. Comment puis-je réinitialiser mon mot de passe?",
    common_qa_5: 'Puis-je annuler déjà envoyé montant le paiement ONEWORLDPAY?',
    common_qa_6: 'Comment puis-je recevoir des paiements via ONEWORLDPAY?',
    common_qa_7: 'Comment puis-je envoyer le paiement via ONEWORLDPAY?',
    common_qa_8:
      'Comment puis-je ajouter un compte bancaire au compte ONEWORLDPAY?',
    common_qa_9:
      'Comment puis-je vérifier le compte bancaire associé à mon compte ONEWORLDPAY?',
    common_qa_10: 'Comment puis-je désactiver le compte limite de ONEWORLDPAY?',
    technical_support: 'Abonnez-vous aux questions techniques et mises à jour.',
    condition_cocopay: "Afficher l'état ONEWORLDPAY",
    muliple_help: "D'autres façons d'obtenir de l'aide",
    trading_help: 'Pour résoudre beaucoup tels problèmes',
    tex_center: 'Centre fiscal',
    tex_help: "Trouvez les formulaires d'impôt et d'autres ressources",
    need_help: 'Contactez-nous',
    help_center: "Contacter l'assistance à la clientèle",
    help_to_center: "Contacter l'assistance à la clientèle",
    prepare: 'Bientôt.',
    fast_help:
      "Racontez-nous votre problème afin que nous puissions plus rapidement ONEWORLDPAY d'aide.",
    my_search: 'Rechercher mon problème',
    common_problem: 'problèmes courants',
    login_problem: 'Problèmes de connexion',
    unkown_charge: "L'accès non autorisé ou sinistres inconnus rapport",
    send_money: "Envoyer de l'argent",
    get_fund: "recevoir de l'argent",
    withdraw_money: "retirer de l'argent",
    pay_cancel: 'Paiement ou annuler la commande',
    pay_hold: 'Paiement en attente ou en attente',
    refund: 'Les remboursements',
    pre_pament: 'paiements pré-approuvés',
    negative_balance: 'solde négatif',
    account_qa_1:
      "ONEWORLDPAY retirer de mon compte de l'état mais il montre que « terminé » Pourquoi est-argent qui ne contient pas de compte bancaire?",
    account_qa_2:
      'Quelle est la raison de mon ONEWORLDPAY de retrait est encore un statut « en attente »?',
    account_qa_3: 'Pourquoi mon retrait en attente?',
    item_title: 'Access Password et compte',
    item_title_2: 'Profil du compte et paramètres',
  },
  business: {
    no_trade: "Il n'y a pas les marchés des changes possibles.",
    view_your_account: 'Afficher lintégralité de votre compte',
    available: 'disponible',
    calculate_late:
      "Nous afficherons l'actif actuel du plus important champ électrique USOT.",
    payment_transfe: 'les transferts de paiement',
    exchange: 'Change de devises',
    currency_update: 'Ajouter un appel',
    update_btn: 'bouton plus',
    currency_cal: 'Convertisseur de devises',
    pay_default: 'Préférences de paiement',
    payment_send: 'Envoyer ou demande de paiement',
    account_list: 'Liste des comptes',
    no_alias: 'Aucun alias',
    new_bank: 'Connectez la nouvelle banque',
    card: 'carte',
    new_card: 'Connectez la nouvelle carte',
    credit: 'crédit',
    preference_payment: 'Choisissez votre mode de paiement en ligne préférés.',
    payment_tip:
      "Lors de l'achat en ligne ou l'envoi de paiement des biens et services à l'aide de ce moyen. Vous pouvez à tout moment choisir un mode de paiement lors de votre commande.",
    payment_more: 'Renseignez-vous sur vos préférences de paiement',
    paymnet_changes: 'équilibre ONEWORLDPAY',
    debit_card: 'Carte de débit',
    currency_tip:
      'Si vous ajoutez une monnaie, tous les paiements futurs reçus dans cette devise seront crédités sur les fonds appropriés. La devise de base est utilisé pour envoyer un paiement de paiement ou de la demande.',
    currency_1: 'Dollar australien',
    currency_2: 'Franc suisse',
    currency_3: 'Couronne tchèque',
    currency_4: 'Couronne danoise',
    currency_5: 'euro',
    currency_6: 'British Pound',
    currency_7: 'Dollar de Hong Kong',
    currency_8: 'forint',
    currency_9: 'Nouveau Shekel israélien',
    currency_10: 'Peso mexicain',
    currency_11: 'Norvège Krone',
    currency_12: 'Dollar néo-zélandais',
    currency_13: 'Peso philippin',
    currency_14: 'zloty polonais',
    currency_15: 'Rouble russe',
    currency_16: 'Couronne suédoise',
    currency_17: 'Dollar de Singapour',
    currency_18: 'Baht',
    currency_19: 'New Taiwan Dollar',
    withdraw_account: 'retrait compte',
    exchanged: "Après l'échange de devises",
    exchange_rate: 'Taux de change',
    exchange_tip:
      "Le taux de change est un montant estimé en fonction du taux de change actuel, les frais d'échange est inclus dans le ONEWORLDPAY.",
    currency_default: '(A) Le Yen japonais est réglé sur la devise par défaut.',
    currency_default_notice:
      'La devise de base est utilisé pour envoyer un paiement de paiement ou de la demande.',
    currency_default_notice2:
      "Fermeture de l'appel n'a pas affiché sur la balance ne reçoit aucun paiement à l'appel.",
    currency_default2: 'JPY (s), la valeur par défaut',
    currency_quit_jp_btn: 'Fermer Dollars',
    currency_quit_btn: 'Quasi',
    bank_account: 'comptes',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: 'balances',
    bank_account_check: 'confirmant la Banque',
    bank_account_remove: 'Supprimer Banque',
    bank_continue: 'Voulez-vous continuer?',
    bank_tip:
      'Les transactions en attente avec les banques sont traitées après la suppression.',
    bank_this_delete: 'Supprimer Banque',
    card_tip:
      "Le compte ONEWORLDPAY Vous voulez l'utiliser sans dépenser ou limites de retrait?",
    card_confirm: 'Vérifiez la carte.',
    card_type: 'type',
    expiry_date: 'expiration',
    card_adress: 'Adresse de facturation',
    card_update: 'carte de mise à jour',
    card_delete: 'Supprimer la carte',
    card_this_delete: 'Supprimer la carte',
    card_tip2:
      'Ce mode de paiement est actuellement préféré. Une fois terminé, vous pouvez définir un mode de paiement préféré différent. Affaire est en cours (a) non défini est traité après la suppression.',
    secure_code: 'code de sécurité',
  },
  shop: {
    shop_list: 'Liste magasin',
    shop_create: 'Boutique créé',
    shop_cre_date: 'ajouté',
    shop_title: 'Nom du magasin',
    shop_id: 'ID magasin',
    shop_state: 'état',
    shop_work: 'travail',
    shop_detail: 'plus',
    shop_retouch: 'cristal',
    shop_settlement: 'Liste des comptes de règlement',
    shop_history: 'transactions',
    no_shop_list: "Il n'y a pas de liste de magasins",
  },
  merchant: {
    create: 'inscription boutique',
    update: 'inscription',
    retouch: 'magasins modifiés',
  },
  pay_legal: {
    service_usage: "ONEWORLDPAY Conditions d'utilisation",
    detail_usage:
      "Les présentes conditions générales seront applicables à la région Asie-Pacifique, en Amérique latine et dans certains pays d'Europe, du Moyen-Orient et les utilisateurs africains. choisissez dans la liste ci-dessous pour afficher les termes et conditions pour les différents pays ou régions,.",
    nation: 'Sélectionnez un pays',
    every_consumer: 'tous les utilisateurs',
    service_agree: 'Votre contrat pour le service ONEWORLDPAY',
    privacy_state: 'Politique de confidentialité',
    purpose_policy: 'ONEWORLDPAY utilisation Politique',
    payment_agreement: 'accord de méthode de paiement ONEWORLDPAY',
    sell_buy: 'Marchand et affaires',
    shop_policy: 'Politiques ONEWORLDPAY Assistance Boutique',
    contract_profit: 'Contrat but lucratif',
    billing_agreement: 'Accord de facturation',
    direct_debit_agreement: 'fonds ONEWORLDPAY reçus et accords de débit',
    additional_info: 'Informations supplémentaires',
    infringement: 'Somyeongseo violations de la politique',
    policy_update: 'Mises à jour des politiques',
    warn1:
      'Informer les consommateurs: service de paiement ONEWORLDPAY est considéré comme un moyen de paiement prépayé (Facility Stored Value) conformément à la loi australienne.',
    warn2:
      "ONEWORLDPAY les propriétaires de moyens de paiement prépayés ⓒ Cocofx Pty Ltd ne nécessite pas l'approbation de l'Autorité de surveillance financière australienne. Nous encourageons également les consommateurs (utilisateurs) sont lus attentivement les présentes Conditions Générales.",
    warn3:
      "Ces conditions d'utilisation et avis fournissent les conditions associées à un service de ONEWORLDPAY particulier.",
  },
  pay_privacy: {
    effective_day: 'Entrée en vigueur le 28 Mars 2019',
    summary: 'résumé',
    personal_data: 'Les données personnelles collectées par ONEWORLDPAY',
    personal_date_cause:
      'Raisons de garder votre ONEWORLDPAY des données personnelles',
    summary_1: 'Nos membres sont',
    summary_2: 'Sites',
    summary_3: 'ou visite',
    summary_4: 'service',
    summary_5: 'Lorsque vous utilisez les utilisateurs de',
    summary_6: 'données personnelles',
    summary_7:
      "Comment collecter et stocker, gérer et partager, en expliquant que le transfert a préparé cette Politique de confidentialité. Cette politique de confidentialité s'applique à vos données personnelles lorsque vous visitez notre site ou utiliser le service, les autres ONEWORLDPAY",
    summary_8: 'utilisateur',
    summary_9:
      'Il ne concerne pas les sites ou ONEWORLDPAY web en ligne ou non la propriété des ajustements, y compris le site ou le service service.',
    summary2_1:
      'ONEWORLDPAY peut vous visitez nos sites ou collecter des informations personnelles lorsque vous utilisez les types de services suivants.',
    summary2_2: 'Utilisation et information Up',
    summary2_3:
      "Lorsque vous vous inscrivez un compte pour utiliser les services de ONEWORLDPAY, pour répondre aux informations nécessaires pour recueillir des données personnelles afin de fournir le service demandé par l'utilisateur.",
    summary2_4:
      "En fonction des services sélectionnés, vous pouvez demander de fournir les informations d'identification requises pour créer un nom d'utilisateur, adresse postale, numéro de téléphone, adresse e-mail, compte.",
    summary2_5:
      'Conditions vous pouvez demander de fournir des données personnelles supplémentaires, en fonction du service.',
    summary3_1: "expérience du trading et de l'information",
    summary3_2:
      "En utilisant les services de ONEWORLDPAY ou si l'accès au site, par exemple, acheter du vendeur, ou la réception de l'argent ou si le traitement d'un paiement ou envoyer de l'argent à des amis et la famille, recueillir d'autres informations relatives à la négociation, ainsi que des informations sur les transactions de ONEWORLDPAY la. Autres informations liées au commerce comprend l'envoi ou demander de l'argent, des biens ou services de paiement de l'argent, le vendeur, y compris des informations sur tous les modes de paiement utilisés pour compléter les informations de l'information sur les transactions et le dispositif, les données de la technologie, des informations de localisation, etc..",
    summary4_1: 'Renseignements sur les participants',
    summary4_2:
      "Lorsque vous utilisez ou l'accès au service site ONEWORLDPAY collecte des données personnelles que les utilisateurs fournissent d'autres participants impliqués dans l'affaire.",
    summary4_3: "Pour envoyer ou de l'argent à la demande",
    summary4_4:
      "Si vous envoyez ou demande d'argent par le service ONEWORLDPAY recueillir votre nom, votre adresse postale, numéro de téléphone, données personnelles telles que reçoivent de l'argent de vos informations de compte financier du participant d'envoyer de l'argent pour vous.",
    summary4_5:
      "La portée des données personnelles demandées par rapport aux participants peut varier en fonction du service utilisé pour envoyer ou de l'argent à la demande.",
    summary5_1:
      'Le paiement des autres personnes au lieu des factures ou facture demandant le paiement à une autre personne',
    summary5_2:
      "Si vous utilisez un service de ONEWORLDPAY pour leur demander de payer la facture au nom d'une autre personne, ou de payer vos factures en leur nom à un autre utilisateur, le nom d'utilisateur, adresse postale, numéro de téléphone, adresse e-mail, la facturation de l'utilisateur au lieu de factures ou d'autres le propriétaire du compte doit recueillir des données personnelles pertinentes, y compris le numéro de compte que vous voulez payer à la place.",
    summary6_1: "Ajouter de l'argent à votre compte",
    summary6_1_1: 'votre compte',
    summary6_2:
      "Pour ajouter de l'argent à d'autres comptes dans le compte de l'utilisateur ou l'utilisateur peut posséder, ou si vous utilisez un service de ONEWORLDPAY pour demander à ajouter au montant de ce compte aux autres utilisateurs de l'autre côté de l'utilisateur pour traiter efficacement votre demande recueillir de l'information ou peut recueillir des informations sur vous de l'autre côté.",
    summary6_3:
      "Par exemple, charger ou d'utiliser la demande des services de ONEWORLDPAY à ajouter au montant dans le compte à un téléphone mobile, vous pouvez recueillir d'autres renseignements, y compris les données personnelles, et le numéro de compte mobile des autres participants.",
    summary7_1:
      'Les informations relatives à la personne de vos amis et contacts',
    summary7_2:
      "Lorsque l'utilisateur se connecte la liste de contacts dans votre compte, il est plus facile de donner aux gens d'aider à traiter quand ONEWORLDPAY avec vos amis et contacts. Pour que l'utilisateur peut utiliser l'appareil, ou mettre en place une connexion entre les plates-formes de médias sociaux ou des dispositifs aux comptes ONEWORLDPAY ou les médias sociaux lorsqu'ils sont connectés à la plate-forme de meilleurs services de ONEWORLDPAY recueillir et utiliser vos informations de contacts de la liste (nom, adresse, adresse e-mail, etc.) ONEWORLDPAY améliorer l'environnement.",
    summary8_1:
      "Les informations que vous choisissez de fournir ONEWORLDPAY afin d'utiliser certains services en ligne ou des services supplémentaires",
    summary8_2:
      "Si la demande ou de participer à la sélection du site à des fonctions de demande ou des services améliorés, ou d'autres fonctions optionnelles, vous pouvez recueillir des informations supplémentaires sur les utilisateurs ONEWORLDPAY.",
    summary8_3:
      "Si les méthodes utilisées pour recueillir des informations de ces services diffèrent de ceux énoncés dans la présente Politique de confidentialité, les informations recueillies au cours d'un avis distinct.",
    summary9_1:
      "Informations pour l'utilisateur lors de l'utilisation du service « non-paiement ONEWORLDPAY »",
    summary9_2:
      "Pour certains services limités peuvent avoir besoin de vous connecter ou utiliser vos paramètres de compte non-paiement. ONEWORLDPAY recueillera vos données personnelles, toutes les méthodes de paiement d'information de l'appareil concerné, les données technologiques, les informations de localisation nécessaires à l'utilisateur de compléter la transaction. Lorsque vous sélectionnez le propriétaire du compte et le paiement de la non-négociation, vous pouvez construire et de recueillir des informations sur les transactions associées à votre compte.",
    summary9_3:
      "Si l'utilisateur sans le propriétaire du compte et sélectionnez le paiement pour la transaction non ONEWORLDPAY, rassemblons et stockons toutes les informations que vous fournissez sont utilisées et partagées conformément aux informations contenues dans la présente Politique de confidentialité.",
    summary10_1: "informations spécifiques à l'utilisateur auprès de tiers",
    summary10_2:
      "D'un tiers, comme marchand, les fournisseurs de données, les bureaux de crédit dans la mesure permise par la loi, vous pouvez obtenir les informations.",
  },
  partner: {
    be_partner: 'Devenez partenaire de ONEWORLDPAY.',
    banner_text:
      'Achats fournisseur de plate-forme, le marché, il est un des opérateurs de support de facturation qui nécessitent un fournisseur de services de paiement peut être un partenaire de ONEWORLDPAY.',
    banner_btn: 'Pour contacter votre gestionnaire de compte',
    benefit: 'avantages ONEWORLDPAY que les partenaires ont droit',
    benefit_1:
      "L'intégration et le support technique des solutions de construction",
    benefit_2:
      "S'il vous plaît ne hésitez pas à contacter notre équipe d'assistance pour vous d'obtenir de l'aide en matière d'intégration de ONEWORLDPAY. portail développeur ONEWORLDPAY peut également être utilisé comme ressource.",
    benefit_3:
      'La croissance des entreprises grâce à des possibilités de marketing',
    benefit_4:
      'Profitez des nombreuses possibilités de commercialisation prévues ONEWORLDPAY peut attirer des clients potentiels.',
    traction: 'Et le remorquage des paiements dans le monde entier.',
    traction1:
      'partenaires ONEWORLDPAY soutiennent une plate-forme innovante pour un bon règlement des vendeurs à ONEWORLDPAY de confiance.',
    traction_btn: 'plus de partenaires',
    program: "ONEWORLDPAY Partner Program est libre d'adhérer.",
    program_1:
      "S'il vous plaît remplir le formulaire en ligne, nous vous contacterons ONEWORLDPAY.",
    program_2:
      "S'il vous plaît décrire les solutions d'affaires opérationnelles et en cours d'exécution.",
    program_3:
      "S'il vous plaît ONEWORLDPAY de contact pour discuter des changements nécessaires.",
    program_4:
      "ONEWORLDPAY intégrer et veillons à ce qu'ils reçoivent le paiement ONEWORLDPAY.",
    program_btn: 'Pour contacter votre gestionnaire de compte',
    common_qa: 'Foire aux questions',
    common_qa1: 'Y at-il des fournisseurs partenaire ONEWORLDPAY?',
    common_qa1_text:
      "partenaire ONEWORLDPAY est la société B2B (business-to-business) qui offre à ses clients des solutions ONEWORLDPAY. ONEWORLDPAY travaille avec des organisations telles que le panier d'achat, les entreprises d'hébergement Web, les développeurs web, fournisseurs de services logistiques et agence de marketing numérique, passerelle de paiement.",
    common_qa2: 'Quels sont les partenaires de ONEWORLDPAY admissibles?',
    common_qa2_text: 'Contactez votre gestionnaire de compte',
    common_qa2_text_2:
      'Vous pouvez obtenir des conseils sur les qualifications des partenaires.',
    common_qa3:
      'Nous fournissons des services de soutien intégrés dans le ONEWORLDPAY?',
    common_qa3_text:
      "Une fois inscrit au programme de partenariat et d'approbation ONEWORLDPAY à se joindre, vous pouvez accéder aux précieux documents intégrés et des forums développeurs. Il peut également obtenir un support intégré pour les consultants du certificat.",
    common_qa4:
      'Il y a aussi un en dehors des affaires de Corée, puis-je inscrire séparément pour chaque pays dans le programme de partenariat?',
    common_qa4_text:
      'Cela dépend du pays dans lequel vous exploitez une entreprise. Dans ONEWORLDPAY déploient représentant des partenaires spécialisés aux besoins régionaux dans divers pays.',
    common_qa4_more: 'Voir le programme de partenariat national offre',
  },
  pay_main: {
    total_product: 'total des produits',
    total_sum: 'agrégat',
    pay_this_account: 'Définissez ce compte comme mode de paiement.',
    bill_show:
      'Les informations de la transaction est affichée comme suit dans le cahier des charges.',
    banner_text: 'ONEWORLDPAY est plus sûr',
    banner_text2: 'Un paiement rapide.',
    banner_text3:
      'Peu importe où le shopping gardera vos informations financières sécurisées.',
    footer_1: 'Termes et conditions',
    footer_2: "Conditions générales d'utilisation",
    footer_3: 'Politique de confidentialité',
    footer_4: "retour d'information",
    footer_5:
      "Avis aux clients: les propriétaires de moyens de paiement prépayés ONEWORLDPAY ⓒ Cocofx Pty Ltd ne nécessite pas l'approbation de l'Autorité de surveillance financière australienne.",
    footer_6: "Conditions d'utilisation",
    footer_7: 'Nous vous encourageons également à lire attentivement.',
    footer_8: 'facturation',
    wallet: 'gestion porte-monnaie',
    last_name: 'sexe',
    card_number: 'Numéro de la carte',
    three_number: 'trois chiffres',
    name: 'nom',
    pay_cocopay: 'Pour payer par ONEWORLDPAY',
    free_shipping:
      "Si le compte ONEWORLDPAY, vous pouvez obtenir expédition de retour gratuit, l'achat de protection.",
    email_phone: 'Numéro de courriel ou par téléphone',
    login_error: 'Avez-vous du mal à la signature?',
    pay_card: 'Paiement par carte',
    cancel_back: 'Annuler et revenir à la page précédente',
  },
  site_map: {
    site_map_tip: 'Un lien qui vous aidera à explorer le compte ONEWORLDPAY.',
    map_fund: 'fonds',
    map_fund_1: 'DÉBITÉES',
    map_fund_2: 'Ma capacité à utiliser le solde est?',
    map_fund_3: "Envoyer ou demande d'argent",
    map_fund_4: 'gestion des appels',
    map_fund_5: 'ONEWORLDPAY mes remises de cartes de débit',
    map_fund_6: 'Obtenez ONEWORLDPAY carte de débit',
    map_fund_7: 'ONEWORLDPAY crédit Calendrier de facturation',
    map_deal: 'affaire',
    map_deal_1: 'Voir toutes les activités de traite',
    map_deal_2: 'Activités vues (y compris le solde et les frais)',
    map_deal_3: 'Voir les graphiques et les tableaux offre',
    map_deal_4: 'Télécharger affaire',
    map_deal_5: 'En réponse à une demande ou rétrofacturation',
    map_deal_6: 'IPN (notification de paiement instantanée) Histoire',
    map_profile: 'Mon profil et vos paramètres',
    map_profile_1: "Miroir d'affaires",
    map_profile_2: 'E-mail, adresse, téléphone ou mise à jour du mot de passe',
    map_profile_3: 'compte bancaire ou mise à jour de la carte',
    map_profile_4: 'Mise à jour Notifications',
    map_profile_5: 'Limites Voir le compte',
    map_profile_6: 'Gestion des utilisateurs',
    map_profile_7: 'Préférences de mise à jour de livraison',
    map_support: 'soutien',
    map_support_1: 'Accédez au Centre for Conflict Resolution',
    map_support_2: 'Accédez au Centre de support',
    map_support_3: 'Contactez-nous',
    map_support_4: 'ONEWORLDPAY information sur les frais de marchand',
    map_report: 'rapport',
    map_report_1: 'Rapport de mettre en place, gérer ou télécharger',
    map_manage: 'outils',
    map_manage_1: 'Voir outil',
    map_manage_2: 'Gestion bouton ONEWORLDPAY',
    map_manage_3: 'Gestion des paiements réguliers',
    map_consum: 'client',
    map_consum_1: 'Voir la liste des clients',
  },
  fee: {
    fee_tip: 'Structure Fief simple',
    fee_banner_1:
      "En règle générale, l'achat est gratuit et peut être soumise à des frais de change.",
    fee_banner_2:
      "Si les ventes ne collent pas avec les frais mensuels de ONEWORLDPAY, ou les frais d'annulation. Après chaque commission ne sera versée que.",
    fee_h2: "En général l'achat est gratuite.",
    fee_text1:
      'Les frais de traitement des paiements sont payés par le vendeur.',
    fee_text2: 'Cependant, vous pouvez échanger des frais est appliqué.',
    fee_more: 'frais de vente en savoir plus',
    fee_text3:
      "Vente par la facture ou le paiement Email site Web (paiement tarifs internationaux standard s'appliquent)",
    fee_text4: 'Des frais fixes en fonction de la réception des appels',
    fee_text5: "frais d'échanges peuvent demander plus.",
    fee_text6:
      'Par exemple, pour un reçu de paiement des frais fixes en USD est de 0,30 $ USD.',
  },
  dash: {
    more: 'plus',
    withdraw_asset: 'retrait des fonds',
    currency: 'monnaie',
    quotes: 'Les factures et des prévisions budgétaires',
    last_6_months: '6 derniers mois',
    make_invoice: 'génération de facture',
    manage_invoice: 'gestion des factures',
    grown_up:
      "S'il vous plaît envoyer à faire croître l'entreprise pour obtenir un devis.",
    un_paid_invocie: 'factures impayées',
    make_quotes: 'génération de devis',
    quotes_1: 'On a proposé des factures impayées.',
    quotes_2: 'facture ONEWORLDPAY',
    quotes_alarm: 'Envoyer des rappels',
    quotes_detail: 'Afficher plus',
    quotes_who: 'Bill à: Choi, So - Jeune',
    latest_act: 'Activité récente',
    act: 'activité',
    received: 'Paiement reçu',
    send: 'de paiement',
    act_record: 'Activité (y compris le solde et les frais)',
    pay_person: 'personnes Biller',
    show_all: 'voir tous les',
    tell_us: "S'il vous plaît dites-nous votre opinion.",
    feed_text:
      "S'il vous plaît prendre un moment pour nous dire votre avis sur les informations d'affichage nouvellement conçu sur cette page. Merci!",
    service: 'formuler des commentaires',
    feed_text_back:
      'Merci pour vos commentaires! Est-ce que notre site est utile?',
    feed_placeholder:
      "S'il vous plaît laissez-moi savoir la raison pour laquelle il y a une meilleure façon que je suis venu aujourd'hui ONEWORLDPAY. Ne pas inclure des informations personnelles, telles que le numéro de compte e-mail ou.",
    feed_p:
      "le personnel du bureau de ONEWORLDPAY et les invités à vos commentaires peuvent être affichés à l'interne, de sorte que vous pouvez le voir, ne laissez aucune information personnelle. problèmes de service à la clientèle, s'il vous plaît cliquer ici. de ONEWORLDPAY",
    feed_protect: 'Politique de confidentialité',
    feed_law: 'Conditions juridiques',
    feed_or: 'et',
    feed_need: 'voir',
    trade_name: 'Nom Deal',
    trade_id: 'ID Deal',
    transaction_type: 'le type de contrat',
    trade_amount: 'paiement',
    detail_show: 'Rechercher',
  },
  shop_detail: {
    detail_info: 'Détails boutique',
    api_signature: 'clé de signature de magasin',
    msg_shop_create: 'Cette boutique a été enregistré.',
    msg_shop_modify: 'Cette boutique a été corrigé.',
  },
  merchant_account: {
    create_account: 'Générer compte de règlement',
    enroll_account: "Compte de règlement d'enregistrement",
    pls_select_account: 'Choisissez établissement compte',
  },
  transaction_detail: {
    transaction_title: 'détails Deal',
    order_id: 'Magasin Numéro de commande',
    pay_account_title: 'Nom du compte de paiement',
    pay_account_number: 'Compte Paiement Nombre',
    pay_account_balance: 'Compte paiement du solde',
    pay_account_selection: 'Sélectionnez un compte pour lequel payer.',
    pay_account_selection_msg: 'Veuillez sélectionner un compte de paiement.',
  },
  guide: {
    guide_title_1: 'Compte bancaire Coco',
    guide_title_2:
      'Comment les transferts et les envois de fonds de Coco Bank?',
    guide_title_3:
      'Profitez des services plus pratiques et sûrs via le compte de Coco Bank.',
    guide_strapline_1:
      'Comptes qui peuvent être supprimés immédiatement sans frais',
    guide_strapline_2: '② Facile à ouvrir un compte rapide de manière simple',
    guide_strapline_3: 'Vestimer',
    guide_strapline_4: 'remise',
    guide_strapline_5:
      'Comptes qui peuvent déposer le plus grand nombre de pièces de monnaie en Corée',
    guide_strapline_6: 'Compte sûr du piratage',
    guide_strapline_7: 'Histoire visuelle Enquête et reçu Disponible',
    guide_strapline_8:
      "Peut être utilisé comme un compte de règlement d'entreprise",
    guide_strapline_9:
      'Transactions rapides via des comptes des transactions C2C et B2C',
    guide_strapline_msg_1:
      "Le transfert de compte de Coco Bank ne se produit pas pour transférer de l'argent.",
    guide_strapline_msg_3:
      "L'ouverture du compte de Coco Bank est de 10 secondes.",
    guide_strapline_msg_4: 'Processus complexe omis.',
    guide_strapline_msg_5:
      'Vous pouvez créer uniquement le nom du compte pour cet actif.',
    guide_strapline_msg_6: 'Transfert via portefeuille',
    guide_strapline_msg_7: "Utilisation de l'adresse du portefeuille",
    guide_strapline_msg_8: 'Charges de frais',
    guide_strapline_msg_9: 'Mise à remise dans Coco Bank',
    guide_strapline_msg_10: 'Utilisation du numéro de compte',
    guide_strapline_msg_11: 'Frais zéro',
    guide_strapline_msg_12:
      "De nombreux types d'accumulations cryptographiques sont émis dans le monde entier. Coco Bank s'occupe de divers accumulations cryptographiques pour aider la commodité des clients conformément à ces changements.",
    guide_strapline_msg_13:
      "La sécurité est le noyau d'inclusions cryptographiques. Coco Bank pense que la sécurité la plus importante et les ingénieurs numériques de plus de cinq ans d'expérience dans chaque domaine ont établi un système de sécurité.",
    guide_strapline_msg_14:
      "Vous pouvez interroger le transfert entre les comptes. Le compte de Coco Bank peut vérifier les banques entre les banques ou d'autres banques, telles que les banques de marché. Si nécessaire, vous pouvez visiter le point et vérifier et sortir l'historique des émissions.",
    guide_strapline_msg_15:
      'Le compte de Coco Bank est lié au compte de paiement et de règlement du marché de Coco. Après avoir enregistré le compte cryptographique cible en tant que compte de règlement, vous pouvez régler les marchandises vendues sur le marché Coco à un cryptopaste.',
    guide_strapline_msg_16:
      "Les frais et les retards se produisent sur la transaction entre l'individu à travers le portefeuille. Coco Bank propose une remise de compte Coco Bank comme moyen de résoudre ce problème. Expérimentez des transactions C2C et B2C sans frais et retards via le compte de Coco Bank.",
  },
  account_transfer: {
    transfer: 'Transfert de compte',
    transfer_list: 'Historique du transfert',
    transfer_list_title: 'Transfert de compte bancaire COCO',
    transfer_list_wallet: 'Autre transfert de portefeuille',
    msg_required_data: "S'il vous plaît entrer toutes les valeurs",
    msg_not_select_withdraw_account:
      "S'il vous plaît sélectionnez le compte de paiement",
    create_transfer_title: 'Transfert de compte',
    from_account_select: 'Sélectionnez le compte de paiement',
    available_transfer: 'les montants de transfert',
    to_account_input: 'Transfert entrée du numéro de compte',
    to_account_confirm: 'Transfert de vérification des comptes',
    to_account_user_name: 'Transfert compte Nom du membre',
    transfer_amount: 'Montant du transfert',
    delete_amount: 'correction',
    all_amount: 'COMPLET',
    description: 'explication',
    transfer_btn: 'transferts',
    transfer_info_check: 'Consultez les informations de demande de transfert',
    from_account_number: 'Retrait Numéro de compte',
    from_asset_title: 'Retrait des actifs compte',
    to_account_number: 'Transfert Numéro de compte',
    success_transfer: 'Transfert a été traitée avec succès.',
    transfer_list_detail: 'Transfert Histoire &',
    search_transfer_asset: 'Recherche par la propriété',
    search_transfer_account: 'Recherche par compte',
    reset: 'initialisation',
    search: 'récupération',
    transfer_list_detail_tit: 'Transfert Détails Détails',
    no_transfer: 'Aucun détail de transfert',
    msg_not_search_account:
      "Le numéro de compte n'existe pas ou est entrée valide.",
    my_account_transfer: 'Mes transferts de compte',
    msg_pls_select_account:
      'Après avoir sélectionné un actif, recherchez le compte.',
    placeholder_amount: "S'il vous plaît entrer le montant de transfert",
    not_search_user_name: 'Identifiants sûr',
    msg_select_asset_search: 'Veuillez sélectionner un compte',
    success_fail: 'Le transfert a échoué.',
    pls_search_asset: 'Recherchez des actifs.',
    pls_search_account: 'Recherchez votre compte.',
    pls_select_asset: 'Veuillez sélectionner un élément.',
    not_exist_account: "Le compte de l'actif n'existe pas.",
    no_inquiry_history: "Il n'y a pas d'historique d'enquête.",
    account_number_list_1:
      'Il y a 6 mois, le débit ne peut pas être interrogé.',
    account_number_list_2: 'Le nombre maximum de vues est de 6 mois.',
    account_number_list_3:
      "Présenter le résultat du transfert actuel est une page qui interroge l'enquête et le transfert de marchands dans Coco Bank. <br /> Si vous souhaitez afficher les résultats du transfert avec d'autres sacs à main, veuillez vérifier le haut du [transfert de bourse] en haut.",
    account_number_list_3_1:
      'La demande de résultats de transfert actuelle est une page pour les demandes de renseignements au sein de Cocobank et les résultats de transfert des magasins affiliés. <br/> Si vous souhaitez vérifier le résultat du transfert vers votre compte Cocobank, veuillez vérifier le [Transfert de compte Cocobank] en haut.',
    today: 'Jour',
    one_week: '1 semaine',
    one_month: '1 mois',
    three_months: '3 mois',
    six_months: '6 mois',
    withdrawal_account_number: 'Numéro de compte de retrait',
    recent_order: 'Dans la dernière commande',
    past_order: "Dans l'ordre passé",
  },
  bank_service_center: {
    title: 'sujet',
    date: 'date',
    state: 'état',
    enter_search_word: 'Entrez vos termes de recherche',
    list: 'liste',
  },
  service_center: {
    view_all: 'Voir tous les',
    contact_history: "Historique de l'enquête",
    privacy_Statement: 'Politique de traitement des informations personnelles',
    would_you_agree: 'Souhaitez-vous accepter ce qui précède?',
    mobile_number: 'Numéro de téléphone portable',
    target_of_inquiry: "Objet de l'enquête",
    inquiry_contents: "Contenu de l'enquête",
    please_enter_your_inquiry: 'Veuillez saisir votre demande.',
    send: 'Envoyer',
    normal_inquiries_received: 'Votre demande a bien été reçue.',
    inquiry_history: "Historique de l'enquête",
    pls_select_inquiry_type: "S'il vous plaît sélectionner le type de contact",
    pls_login_to_use_inquiry: '1, Connectez-vous à premières enquêtes.',
    non_member_login: 'Connexion non-membre',
    contact_id: 'Contact ID',
    view_inquiry: 'Afficher le contact',
    service_center: 'centre client',
    inquiry_details: 'Détails de contact',
    msg_enter_title: "S'il vous plaît donner un titre.",
    msg_enter_your_content: "S'il vous plaît entrer vos informations.",
    msg_pls_login: "S'il vous plaît Connectez-vous.",
    go_back: 'Retour',
    re_contact: 'Matériau du contact',
    contents: 'contenu',
    msg_no_inquiry_history: 'Aucun détail de contact.',
    msg_require_login_additional_authentication:
      'Vous devez être connecté ou une authentification supplémentaire.',
    when_you_member: "Lorsqu'un membre",
    msg_inquiry_history_can_view_after_login:
      'Les membres des coordonnées peuvent être consultés après la connexion.',
    non_member: 'Lorsque les non-membres',
    lookup_inquiry: 'Recherche de contacts',
    msg_enter_inquiry_id: "S'il vous plaît entrer le numéro de contact.",
    msg_enter_password_when_registering_your_inquiry:
      "S'il vous plaît entrer le mot de passe que vous définissez lorsque vous appelez registre.",
    frequently_asked_questions: 'Foire aux questions',
    msg_enter_your_password: "S'il vous plaît entrer votre mot de passe.",
    pls_search_fap: "S'il vous plaît rechercher des questions.",
    msg_source_filename_none: "Il n'y a pas d'image attachée.",
    super_inquiry: 'Haut',
  },
  modal: {
    not_seeing_day: 'Pas vu pendant la journée',
  },
  login_guide_modal: {
    title: "L'information",
    sub_title:
      "Le système de connexion sera remanié pour que les membres puissent utiliser l'échange en douceur.",
    content:
      "[Avant le changement] <br/> Identifiant créé lors de votre première inscription <br/><br/> [Après le changement] <br/> Modifiez votre numéro de téléphone ou votre adresse e-mail <br/><br/> Pour vous connecter jusqu'à ce que le système de connexion soit réorganisé, connectez-vous simplement avec l'ID que vous avez créé lors de votre première inscription.",
  },
  affiliate: {
    affiliate_occur_list: 'Historique des allocations',
    affiliate_adjust_list: "Détails du règlement de l'allocation",
    allowance_balance_asset: 'Solde des allocations par actif',
    list_allowance_balance_asset: 'Liste du solde des allocations par actif',
    search_by_asset: 'Recherche par actif',
    allowance_search: "Recherche d'allocation",
    generator: 'Générateur',
    beneficiary: 'Bénéficiaire',
    benefactor: 'Bienfaiteur',
    behavior_type: 'Type de comportement',
    target_unique_number: 'Numéro unique cible',
    date_of_occurrence: "Date de l'événement",
    application_policy_name: "Nom de la stratégie d'application",
    beneficiary_type: 'type de bénéficiaire',
    benefactor_type: 'type de bienfaiteur',
    target_amount: 'Montant cible',
    principal_amount: 'Le montant principal',
    allowance: 'rémunération supplémentaire',
    allowance_assets: 'Actifs d’allocation',
    allowance_amount: "Montant de l'allocation",
    affiliate_log: 'Répartition des allocations',
    allowance_settlement: 'Règlement des indemnités',
    allowance_settlement_info: 'Informations sur le règlement des allocations',
    name_asset_settled: 'Nom des actifs à régler',
    balance_receive_payment: 'Solde à payer',
    select_account_settled: 'Sélectionnez le compte à régler',
    no_affiliate_log: "Il n'y a aucune allocation encourue.",
    no_affiliate_balance:
      "Il n'y a pas de liste des soldes de provisions par actif.",
    no_affiliate_adjust: "Il n'y a aucun historique de paiement d'allocation.",
    asset_name: "Nom de l'actif",
    asset_code: "Code d'actif",
    balance: 'équilibre',
    cumulative_amount: 'Montant cumulé',
    please_select_account: 'Veuillez sélectionner un compte',
    calculate: 'Calculer',
    settle: 'Régler',
    calculate_amount: 'Montant du règlement',
    account_number: 'Numéro de compte',
    registration_date: "Date d'inscription",
    number: 'nombre',
  },
  coin_name: 'Nom de la pièce',
  main_function: 'Fonction rincipale',
  disclosure_ing: 'En cours de',
  quick_service: 'service rapide',
  new_account: 'nouveau compte',
  social_login: 'Connexion sociale',
  way_to_find: 'la façon de trouver',
  cocobank_korea_head_office: 'Siège de ONEWORLDPAY Corée',
  cocobank_branch_office: 'Succursale ONEWORLDPAY Shinsa',
  address_head_office: '528 Eonju-ro, Gangnam-gu, Séoul',
  address_branch_office: '803 Nonhyeon-ro, Gangnam-gu, Séoul',
  map: 'Carte',
  korean_language_counseling: 'Conseils en coréen',
  hours_of_business: '10h00 à 19h00 en Corée (sauf les jours fériés)',
  overseas_consultation: "Consultation à l'étranger",
  email_consultation: 'Consultation par courriel',
  exchange_price: 'Change de devises / prix',
  market_price_check: 'Contrôle des prix du marché',
  full_account_inquiry: 'Demande de compte complète',
  exchange_details_check: 'Vérification des détails du change de devises',
  cryptocurrency_exchange_history: 'Historique du change de devises',
  deposit_account_inquiry: 'Demande de compte de dépôt de fonds',
  transfer_result_check: 'Vérification des résultats de transfert',
  dormant_account_check: 'Vérification de compte dormant',
  account_and_other_case_status:
    'Vérifier le compte ONEWORLDPAY et le statut des autres cas',
  account_and_other_wallet: 'Vérifiez le compte ONEWORLDPAY et le portefeuille',
  account_search: 'Recherche de compte ONEWORLDPAY',
  other_wallet_search: 'Autre transfert de portefeuille',
  error_remittance:
    "Consentement à renvoyer la remise d'erreur dans ONEWORLDPAY",
  transfer: 'Transfert',
  other_wallets_transfer:
    'Vérifier les autres portefeuilles / résultats de transfert',
  other_wallets_transfer_search: "Recherches d'un autre transfert de bourse",
  frequently_used_accounts:
    'Enregistrer / gérer les comptes fréquemment utilisés',
  new_demand_account: 'Nouveau compte à la demande',
  new_installment_savings_account: "Nouveau compte d'épargne à tempérament",
  new_deposit_account: 'Nouveau compte de dépôt à terme',
  check_account_progress_account: 'Nouveau compte de dépôt à terme',
  download: 'Télécharger',
  withdrawal: 'Retrait',
  Smart_window_withdrawal: 'Retrait de fenêtre intelligente',
  smart_ATM_withdrawal: 'Retrait au guichet automatique intelligent',
  customer_service: 'Service Clients',
  notice: 'Remarquer',
  one_one_inquiry: 'Enquête 1: 1',
  inquiry_details: "Détails de l'enquête",
  frequently_asked_questions: 'Questions fréquemment posées',
  server_notice: 'Avis du serveur',

  service_hours: "Heures d'ouverture du service de satisfaction client",
  all_day_long: '(Demandes disponibles 24h / 24)',
  online_service_hours: "Heures d'utilisation de ONEWORLDPAY en ligne",
  unusable_hours:
    '24 heures sur 24, 7 jours sur 7 (23: 30-24: 00 non disponible)',
  offline_hours: 'Heures de banque hors ligne',
  offline_bank_hours: '(hors week-end et jours fériés)',

  management: 'la gestion',
  secure_management: 'Authentification / gestion sécurisée',
  fund_limit_management: 'Gestion des limites de fonds',
  issue_details_check: 'Vérification des détails du problème',
  part_of_news: "C'est la partie des nouvelles.",
  part_of_notice: "C'est la partie de l'annonce.",
  full_menu: 'Menu entier',
  individual: 'individuelle',
  key_coin:
    'Pièce clé de ONEWORLDPAY qui connecte la crypto-monnaie à la monnaie réelle',
  limitation_info:
    'Informations sur les restrictions de limite pour éviter les dommages à la fraude financière des télécommunications',
  limitation_info_1:
    "Dans la mesure où un compte de paiement à vue n'est pas ouvert en face à face, la limite de retrait (transfert) via des appareils automatisés et Internet est limitée à {0} USOT par jour.",
  limitation_info_2:
    "Les données d'authentification objective pour confirmer le but de la transaction peuvent être présentées à l'agence et la limite peut être levée dans «Gestion> Authentification / Gestion de la sécurité».",
  limitation_info_3:
    'Lorsque vous utilisez Internet banking, vous devez vous inscrire avec un compte de retrait pour effectuer une transaction de transfert.',
  limitation_info_4:
    'Seuls 5 comptes peuvent être ouverts par limite de crypto-monnaie.',
  limitation_notice: 'Remarquer',
  limitation_notice_1:
    "L'abonnement bancaire par Internet peut être appliqué en liant depuis l'écran de finalisation après l'ouverture d'un compte de dépôt / retrait.",
  limitation_notice_2:
    "Veuillez noter que les clients de services bancaires en ligne existants peuvent s'inscrire pour des comptes de retrait via Internet Banking uniquement lorsque la catégorie d'enregistrement du compte de retrait est Internet + succursale.",
  limitation_notice_3:
    "Vous devez être une authentification sécurisée pour vous assurer que vous êtes plus facile de mener votre transfert vers Internet Banking. Après le processus de certification, veuillez améliorer la notation et poursuivre la comptabilité et l'arrangement du système de comptabilité.",

  new_subscription: 'Nouvelle inscription',
  new_subscription1_1:
    "Lorsque vous cliquez sur le nouveau bouton d'inscription, vous recevrez votre propre compte ",
  new_subscription1_2:
    'ONEWORLDPAY et une adresse de dépôt liée à un portefeuille externe.',
  new_subscription2_1:
    "Assurez-vous de le savoir avant de déposer! Il n'y a pas de frais si vous transférez de l'argent d'un compte dédié à ONEWORLDPAY vers votre compte. Seul le ",
  new_subscription2_2:
    "peut être déposé sur le compte / l'adresse émise lors de la nouvelle inscription. Les erreurs / pertes qui peuvent survenir si vous essayez de déposer d'autres actifs numériques à l'adresse sont irrécupérables. Après 1 confirmation, elle est reflétée dans le solde lors du processus de dépôt. Le processus de dépôt est automatique et le temps requis peut varier en fonction des conditions du réseau. L'adresse ci-dessus est pour le dépôt uniquement.",
  new_subscription3_1: 'Vous pouvez déposer ',
  new_subscription3_2: 'avec un nouvel abonnement qui vous est attribué.',
  new_subscription4: 'Avez-vous accepté et compris ce qui précède?',

  created_account_number: 'Numéro de compte créé',
  cocobank_exclusive_account: 'ONEWORLDPAY Numéro de compte dédié',
  depositing_external_wallet:
    "Lors du dépôt de ONEWORLDPAY à partir d'un portefeuille externe",
  use: 'Utiliser',
  we_future: 'notre futur',
  pop_cocobank: 'ONEWORLDPAY',
  fourth_industry: 'Leader dans la quatrième industrie',
  oc_15: '15 octobre',
  officially_open: 'Officiellement ouvert!',
  head_branch_office:
    'Siège social en Corée (succursale de Jamsil) / 1re succursale (succursale de Sinsa)',
  sep_15: '15 septembre à 17h',
  open_popup: 'Ouvert',
  thanks_for: 'Merci pour vos encouragements.',

  direct_exchange: {
    sell_buy_assets: 'Actifs à vendre et à acheter',
    replace_assets: 'Bien à remplacer',
    ccm_exchange_rate: 'CCM détenant un taux de change préférentiel',
    buy_sell_percent: 'Acheter -10% Vendre + 10%',
    expected_property: 'Propriété attendue',
    preferential_property: 'Propriété préférentielle',
  },

  event_banner: {
    clap:
      'Gardez un hébergement en cryptage avec COCO BANK <span class="color-common">CLAP</span>.',
    month_hotcoupon: 'Découvrez le coupon HOT de ce mois-ci.',
    hotcoupon_sub: "Des taux de change aux différents coupons d'affiliation!",
    grab_bug: 'Attrapez le bogue',
    grab_bug_sub:
      'Veuillez laisser une demande 1: 1. Les prix sont attribués par loterie.',
    event2_sub_title: 'Les taux plus élevés.<br>Rendements encore plus élevés.',
    event2_title: '',
    event2_text: 'Devenez membre du CCM et recevez un dividende!',
    event2_btn: "S'inscrire",
  },
  news_lists: {
    news_list_1:
      '프라비코, iq옵션과 같은 방대한 트렌젝션을 일으키는 거래소가 될 것',
    news_list_2:
      'GCC 코인 10월 15일 포블게이트에 상장. 비트코인처럼 안정화 된 코인이 목표',
    news_list_3: '프라비코, 의료산업에 블록체인 기술 접목한다',
    news_list_4: '디파이 열풍! 그 명과 암',
    news_list_5:
      '은행을 대체할 수 있을까? 블록체인 보관과 검증은 어떻게 이루어지나',
    news_list_6: '블록체인은 식품 유통에 혁신적인 발전을 가져올 것이다',
    news_list_7: '가장 혁명적인 화폐 비트코인 탄생 배경은?',
  },
  pop_notice: {
    notice_close: 'fechar',
    notice_today: 'Não vendo hoje',
  },
  clap: {
    getting_started_clap: 'Méthode de réglage initial',
    how_to_initialize_clap: 'Comment réinitialiser',
    getting_started_ledger_live: 'Comment configurer Ledger Live',
    install_coin_app: "Liaison de l'application de pièces de monnaie",
    start_text_1:
      "1. Après avoir connecté le CLAP et le connecteur USB fourni à l'ordinateur, vérifiez la phrase «Bienvenue» pour confirmer qu'il s'agit d'un nouveau produit.",
    start_text_2:
      '2. Appuyez sur le bouton droit et lorsque le message «Configurer comme nouvel appareil» apparaît, appuyez sur les deux boutons du haut en même temps.',
    start_text_3:
      "3. Après avoir confirmé la phrase «Choisir le code PIN», un écran de saisie d'un code PIN à 8 chiffres apparaît. Appuyez sur les deux boutons pour définir le code PIN.",
    start_text_4:
      '4. Une fois la configuration du code PIN terminée, le message Confirmer le code PIN apparaît. Saisissez à nouveau le code PIN en appuyant sur les deux boutons.',
    start_text_5:
      "5. Lorsque le réglage du code PIN est terminé, appuyez sur le bouton droit pour afficher la première phrase parmi 24 phrases. Écrivez le code au dos de la carte de restauration importante en fonction du numéro affiché à l'écran.",
    start_text_6:
      "6. Lorsque l'écriture est terminée, entrez les codes de restauration de 1 à 24 qui correspondent aux nombres un par un.",
    start_text_7:
      '7. Lorsque le message Appuyez sur les deux boutons pour continuer apparaît, appuyez sur les deux boutons en haut pour continuer.',
    init_text_1:
      "1. Avant l'initialisation, vérifiez d'abord si vous disposez d'une carte de récupération et d'un code de récupération importants.",
    init_text_2:
      "2. Il existe deux manières d'initialiser. Premièrement, si CLAP est connecté au PC et que le code PIN est incorrect 3 fois de suite, il est automatiquement initialisé.",
    init_text_3:
      "3. Ensuite, connectez le CLAP au PC et entrez le code PIN pour déverrouiller. Ensuite, allez dans Paramètres> Sécurité> Réinitialiser tout dans l'ordre.",
    init_text_4:
      "4. Appuyez de nouveau sur Réinitialiser tout entre Annuler et Tout réinitialiser pour procéder à l'initialisation.",
    init_text_5: "5. Entrez le code PIN pour terminer l'initialisation.",
    init_text_6: "6. L'initialisation est terminée.",
    ledger_live_text_1:
      "1. Entrez start.ledgerwallet.com dans la barre d'adresse Internet.",
    ledger_live_text_2:
      "2. Cliquez sur l'application Ledger Live à l'étape 1 pour installer l'application sur votre mobile ou votre PC.",
    ledger_live_text_3:
      '3. Lorsque le message Bienvenue dans Ledger Live apparaît, cliquez sur Commencer pour continuer.',
    ledger_live_text_4:
      '4. Vous serez présenté avec 4 options. Si vous achetez un nouveau CLAP et procédez à son exécution, vous pouvez sélectionner le n ° 1 et les autres peuvent être sélectionnés en fonction de votre situation.',
    ledger_live_text_5:
      '5. Appuyez sur 3 lorsque le réglage initial est terminé pour continuer.',
    ledger_live_text_6:
      '6. Sélectionnez le Ledger Nano S parmi les trois options et appuyez sur Continuer.',
    ledger_live_text_7:
      '7. Il existe trois listes de contrôle. Veuillez le régler en fonction de votre situation actuelle.',
    ledger_live_text_8:
      '8. Après avoir vérifié la liste de contrôle, cliquez sur le troisième Vérifier maintenant.',
    ledger_live_text_9:
      "9. Connectez le CLAP à l'ordinateur et déverrouillez le CLAP. (Il s'agit du processus de vérification de l'authenticité)",
    ledger_live_text_10:
      '10. Si votre appareil est authentique sur la troisième liste de contrôle, cliquez sur Continuer en bas à droite.',
    ledger_live_text_11:
      "11. La page de configuration du mot de passe apparaît. Vous pouvez ou non définir un mot de passe. Si vous souhaitez définir un mot de passe, veuillez cliquer sur Continuer / Ignorer cette étape en bas à droite après l'avoir saisie.",
    ledger_live_text_12:
      '12. Cliquez sur Continuer en bas à droite pour continuer.',
    ledger_live_text_13: '13. Le paramétrage de Ledger Live est terminé.',
    coin_app_text_1:
      '1. Allumez le Ledger Live précédemment installé et cliquez sur Aller au gestionnaire au centre.',
    coin_app_text_2: '2. Connectez CLAP au PC et entrez le CODE PIN',
    coin_app_text_3:
      '3. Lorsque vous avez entré le CODE PIN, appuyez sur les deux boutons supérieurs en même temps pour continuer.',
    coin_app_text_4:
      '4. Recherchez la crypto-monnaie que vous avez en bas et cliquez sur Installer à droite pour créer un lien.',
    detail_to_buy: 'Détails et lieu d`achat',
    detail_content1_1:
      "Le clap est logique que le portefeuille de chiffrement de l'utilisateur soit configuré pour s'assurer que l'actif est maintenu en toute sécurité.",
    detail_content1_2:
      "L'industrie financière mondiale évolue rapidement grâce à la découverte et à l'innovation des nouvelles technologies. Les cryptures ont également changé et appliquées selon ces changements, et de nombreuses sociétés mondiales ont attiré une attention de nouveau sur la valeur de la crypto.",
    detail_content1_3:
      "Les utilisateurs à long terme ont plus de problèmes sur la sécurité des actifs en raison de la nature du cryptage utilisé uniquement sous forme d'informations sur un ordinateur.",
    detail_title_2: 'Le service fourni par la clap est certain.',
    detail_content2_1:
      "Coco Bank a jugé qu'une douce -wallette qui stocke des clés privées dans le cloud est vulnérable aux hacks externes, et une question de sécurité se produira. Nous suggérons de résoudre le clap de portefeuille de résolution qui complète ces problèmes.",
    detail_content2_2:
      "Le clap prend en charge jusqu'à huit applications et peut conserver une variété de chiffrement tels que des monnaies de bits, un front et des nids. Vous pouvez également conserver des actifs en toute sécurité des hacks externes car ce n'est pas un portefeuille qui n'est pas toujours connecté à Internet.",
    detail_title_3: 'Sécurité',
    detail_content3_1:
      'Clap est une collaboration (portefeuille froide), une collaboration avec "Ledger" et une collaboration avec une entreprise de solutions de sécurité professionnelle de cryptage global pour résoudre les problèmes de sécurité d\'un mur à chaud (portefeuille à chaud).',
    detail_content3_2:
      'Le clap a été appliqué par une solution de sécurité construite par 130 ingénieurs mondiaux avec des connaissances et une expérience de sécurité numérique. Nous avons inséré les derniers puces de code PIN de sécurité utilisées par les passeports et les cartes de crédit pour améliorer la sécurité.',
    detail_content3_3:
      "Même si vous perdez le clap, vous pouvez conserver les actifs que vous possédez par l'utilisateur via le nouveau périphérique de clap.",
    detail_title_4: 'commodité',
    detail_content4_1:
      "Vous pouvez entrer la clé secrète à l'aide de deux boutons situés en haut de la clap.",
    detail_content4_2:
      "Nous avons soutenu plus de 40 chiffres, notamment Bitcoin, Etherurum et XRP, et envisagent de la commodité de l'utilisateur.",
    detail_title_6: 'COMME',
    detail_content6_1:
      "A / S pour les appareils de produit est une année à compter de la date d'achat.",
    detail_content6_2:
      'Si A / S est requis, veuillez visiter la banque Coco avec le corps de la clap.',
    detail_content6_3:
      "Un numéro de série attaché à l'arrière du clap pour A / S est requis. A / S ne peut pas être utilisé pour saper ou supprimer le numéro de série.",
    detail_content6_4:
      "A / S peut ne pas être possible en fonction du produit du produit causé par votre insouciance et l'état du produit.",
    detail_title_7: 'Remarquer',
    detail_content7_1:
      'Les services en ligne de Clap ne sont pas liés à Coco Bank car ils sont desservis par le livre.',
    detail_content7_2:
      "Si vous utilisez le produit, veuillez noter que la question du piratage de l'extérieur provoquée par le problème de piratage externe causé par les insouciants (perte, la restauration et la connexion du code PIN au PC infecté) n'est pas responsable de la banque Coco.",
    detail_content7_3:
      "Les services en ligne fournis par «Ledger Live» ou le livret ne sont pas pertinents pour l'argent que l'utilisateur obtenu par l'utilisateur n'est pas pertinent pour la Banque Coco.",
    detail_title_8: 'Acheter',
    detail_content8_1: 'Co.u Co.u (Café): 430 1er étage',
    detail_title_9: 'Réception A / S',
    detail_content9_1: 'Coco Bank: Séoul, Gangnam-gu, Séoul 528 2ème étage',
    detail_content9_2:
      "N'hésitez pas à nous contacter avec le Kozuko Koh le plus proche, ou AIDE@cocobank.com.",
  },
}
